/* =========================================================================
 * BB-CUSTOM (Battle Bear) – Singles Kiosk v2
 * -------------------------------------------------------------------------
 * Touch-Einzelkartensuche für Laden-Tablets im Stil von Cardmarket.
 *
 *  Daten   Je Spiel werden ALLE verfügbaren Einzelkarten (Tag + Produkttyp) seitenweise über die
 *          Storefront API geladen (250 je Abfrage) und in IndexedDB zwischengespeichert.
 *          Danach laufen Suche, Filter, Gruppierung und Seitenwechsel komplett im Browser.
 *          -> unabhängig von Shopify-Filtern (die ab 5000 Produkten nicht mehr greifen).
 *  Felder  Metafelder laut Section-Einstellungen; fehlen sie, wird der Produkttitel zerlegt:
 *          "<Name> [(V.x)] <SET>-<NR> <Seltenheit> <Zustand> <Sprache> [Foil]"
 *  UI      Logo-Leiste (Spiele) · Sidebar-Filter · Suche mit Vorschlägen (DE/EN) ·
 *          Ergebnisse gruppiert nach Kartenname, Warenkorb-Button je Version · Idle-Reset.
 *
 * Konfiguration kommt als JSON aus sections/bb-singles-kiosk.liquid (#singles-kiosk-config).
 * ========================================================================= */
(function () {
  'use strict';

  const mount = document.getElementById('singles-kiosk-app');
  const configEl = document.getElementById('singles-kiosk-config');
  if (!mount || !configEl) return;

  let CFG;
  try {
    CFG = JSON.parse(configEl.textContent);
  } catch (e) {
    mount.innerHTML = '<div class="kx-boot">Kiosk configuration error / Kiosk-Konfiguration fehlerhaft.</div>';
    return;
  }

  // Texte in der aktiven Shopsprache (aus locales/*.json über snippets/bb-i18n.liquid)
  const I18N = CFG.i18n || {};
  const T = (key, vars) => {
    let s = I18N[key] != null ? String(I18N[key]) : key;
    if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(v);
    return s;
  };
  const LOCALE = CFG.locale || document.documentElement.lang || 'de';

  // Sprachumschalter (nur wenn der Shop mehrere Sprachen hat)
  const LANGS = Array.isArray(CFG.languages) ? CFG.languages.filter((l) => l && l.code) : [];
  const FLAGS = {
    de: '<svg viewBox="0 0 5 3" aria-hidden="true"><path fill="#000" d="M0 0h5v1H0z"/><path fill="#D00" d="M0 1h5v1H0z"/><path fill="#FFCE00" d="M0 2h5v1H0z"/></svg>',
    en: '<svg viewBox="0 0 7410 3900" aria-hidden="true"><path fill="#b22234" d="M0 0h7410v3900H0z"/><path stroke="#fff" stroke-width="300" d="M0 450h7410m0 600H0m0 600h7410m0 600H0m0 600h7410m0 600H0"/><path fill="#3c3b6e" d="M0 0h2964v2100H0z"/><g fill="#fff"><circle cx="370" cy="300" r="95"/><circle cx="988" cy="300" r="95"/><circle cx="1606" cy="300" r="95"/><circle cx="2224" cy="300" r="95"/><circle cx="679" cy="720" r="95"/><circle cx="1297" cy="720" r="95"/><circle cx="1915" cy="720" r="95"/><circle cx="2533" cy="720" r="95"/><circle cx="370" cy="1140" r="95"/><circle cx="988" cy="1140" r="95"/><circle cx="1606" cy="1140" r="95"/><circle cx="2224" cy="1140" r="95"/><circle cx="679" cy="1560" r="95"/><circle cx="1297" cy="1560" r="95"/><circle cx="1915" cy="1560" r="95"/><circle cx="2533" cy="1560" r="95"/><circle cx="370" cy="1900" r="95"/><circle cx="988" cy="1900" r="95"/><circle cx="1606" cy="1900" r="95"/><circle cx="2224" cy="1900" r="95"/></g></svg>',
  };
  const flagFor = (code) => FLAGS[String(code).toLowerCase().split('-')[0]] || '';
  // Wechselt die Shopsprache über das Shopify-Lokalisierungsformular (Warenkorb und gewähltes Spiel bleiben erhalten)
  function switchLanguage(code) {
    if (!code || code === LOCALE) return;
    const root = CFG.localeRoot && CFG.localeRoot !== '/' ? CFG.localeRoot : '';
    let path = location.pathname;
    if (root && (path === root || path.startsWith(root + '/'))) path = path.slice(root.length) || '/';
    const form = document.getElementById('kx-localization');
    if (form) {
      form.querySelector('[name="locale_code"]').value = code;
      let ret = form.querySelector('[name="return_to"]');
      if (!ret) {
        ret = document.createElement('input');
        ret.type = 'hidden';
        ret.name = 'return_to';
        form.appendChild(ret);
      }
      ret.value = path + location.search;
      form.submit();
    } else {
      location.href = (code === CFG.primaryLocale ? '' : '/' + code) + path + location.search;
    }
  }

  // Modus: 'kiosk' (Laden-Tablet, eigenes Layout) oder 'deck' (Decklisten-Import auf einer normalen Shopseite)
  const DECK = CFG.mode === 'deck';

  const SHOP_DOMAIN = window.Shopify?.shop || location.host;
  const API_URL = `https://${SHOP_DOMAIN}/api/${CFG.apiVersion || '2026-04'}/graphql.json`;
  const PAGE_SIZE = CFG.pageSize || 24;
  const CACHE_MS = (CFG.cacheMinutes || 15) * 60 * 1000;
  const IDLE_MS = (CFG.idleSeconds || 120) * 1000;
  const GAMES = (CFG.games || []).filter((g) => g.tag);
  const MAX_QTY_UNTRACKED = 99;

  // Vorausgewähltes Spiel:
  //   1. Link-Parameter ?spiel=<tag> (oder ?game=<tag>), z. B. /pages/singles-kiosk?spiel=pkm
  //      – akzeptiert Tag, Name des Spiels ("pokemon") oder Block-ID
  //   2. Theme-Editor: Block "Spiel" → "Beim Öffnen direkt anzeigen"
  //   3. Nur ein Spiel konfiguriert
  // Nach dem Inaktivitäts-Reset geht der Kiosk wieder auf dieses Spiel (statt auf den Startbildschirm).
  const URL_PARAM = 'spiel';
  function findGame(value) {
    const v = String(value || '').trim().toLowerCase();
    if (!v) return null;
    const n = v.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '');
    return (
      GAMES.find((g) => g.tag.toLowerCase() === v || g.id === value) ||
      GAMES.find((g) => g.label.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '').startsWith(n)) ||
      null
    );
  }
  const initialParams = new URLSearchParams(location.search);
  const DEFAULT_GAME =
    findGame(initialParams.get(URL_PARAM) || initialParams.get('game')) || GAMES.find((g) => g.preselect) || (GAMES.length === 1 ? GAMES[0] : null);

  // Aktuelles Spiel in der Adresszeile mitführen (Link teilbar, Neuladen bleibt beim Spiel)
  function syncUrl(game) {
    try {
      const u = new URL(location.href);
      u.searchParams.delete('game');
      if (game) u.searchParams.set(URL_PARAM, game.tag);
      else u.searchParams.delete(URL_PARAM);
      if (u.href !== location.href) history.replaceState(history.state, '', u.href);
    } catch (e) {
      /* egal */
    }
  }
  const PRINTS_COLLAPSED = 4; // eingeklappt: so viele Prints (Bilder) je Karte
  const OFFERS_PER_PRINT = 3; // eingeklappt: so viele Versionen je Print

  // ---------------------------------------------------------------------------------------------
  // Stammdaten
  // ---------------------------------------------------------------------------------------------
  const CONDITIONS = [
    { code: 'MT', label: 'Mint', words: ['mint', 'mt'] },
    { code: 'NM', label: 'Near Mint', words: ['near mint', 'nm'] },
    { code: 'EX', label: 'Excellent', words: ['excellent', 'ex'] },
    { code: 'GD', label: 'Good', words: ['good', 'gd'] },
    { code: 'LP', label: 'Light Played', words: ['light played', 'lightly played', 'lp'] },
    { code: 'PL', label: 'Played', words: ['played', 'pl'] },
    { code: 'PO', label: 'Poor', words: ['poor', 'po'] },
  ];
  // Kurzerklärungen nach den Cardmarket-Zustandsrichtlinien (help.cardmarket.com/de/CardCondition), Texte: bb.kiosk.cond_*
  const COND_INFO = Object.fromEntries(['MT', 'NM', 'EX', 'GD', 'LP', 'PL', 'PO'].map((c) => [c, T(`cond_${c.toLowerCase()}`)]));
  const COND_RANK = Object.fromEntries(CONDITIONS.map((c, i) => [c.code, i]));
  const COND_LABEL = Object.fromEntries(CONDITIONS.map((c) => [c.code, c.label]));

  // Cardmarket idLanguage -> Kürzel/Label; "words" für das Lesen aus dem Titel
  const LANGUAGES = [
    { id: '1', code: 'EN', label: 'Englisch', words: ['englisch', 'english'] },
    { id: '2', code: 'FR', label: 'Französisch', words: ['französisch', 'french'] },
    { id: '3', code: 'DE', label: 'Deutsch', words: ['deutsch', 'german'] },
    { id: '4', code: 'ES', label: 'Spanisch', words: ['spanisch', 'spanish'] },
    { id: '5', code: 'IT', label: 'Italienisch', words: ['italienisch', 'italian'] },
    { id: '6', code: 'ZH', label: 'Chinesisch (vereinfacht)', words: ['chinesisch (vereinfacht)', 's-chinese'] },
    { id: '7', code: 'JP', label: 'Japanisch', words: ['japanisch', 'japanese'] },
    { id: '8', code: 'PT', label: 'Portugiesisch', words: ['portugiesisch', 'portuguese'] },
    { id: '9', code: 'RU', label: 'Russisch', words: ['russisch', 'russian'] },
    { id: '10', code: 'KO', label: 'Koreanisch', words: ['koreanisch', 'korean'] },
    { id: '11', code: 'TW', label: 'Chinesisch (traditionell)', words: ['chinesisch (traditionell)', 't-chinese'] },
  ];
  const LANG_BY_ID = Object.fromEntries(LANGUAGES.map((l) => [l.id, l]));
  const LANG_BY_CODE = Object.fromEntries(LANGUAGES.map((l) => [l.code, l]));
  const langName = (code) => (I18N[`lang_${String(code).toLowerCase()}`] ? T(`lang_${String(code).toLowerCase()}`) : LANG_BY_CODE[code]?.label || code);

  // Standard = Abrufreihenfolge (Index wird nach Anlagedatum, neueste zuerst, geladen) -> beim Nachladen
  // werden ältere Karten nur hinten angehängt, nichts springt.
  const SORTS = [
    ...(DECK ? [{ id: 'deck', label: T('sort_deck') }] : []),
    { id: 'new', label: T('sort_new') },
    { id: 'name', label: T('sort_name') },
    { id: 'name_desc', label: T('sort_name_desc') },
    { id: 'price', label: T('sort_price') },
    { id: 'price_desc', label: T('sort_price_desc') },
    { id: 'set', label: T('sort_set') },
  ];

  // ---------------------------------------------------------------------------------------------
  // Hilfsfunktionen
  // ---------------------------------------------------------------------------------------------
  const esc = (s) =>
    String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  // Für Suche: Kleinbuchstaben, Akzente weg, ß->ss, Satzzeichen zu Leerzeichen
  const norm = (s) =>
    String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

  const moneyFmt = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CFG.currency || 'EUR' });
  const money = (cents) => moneyFmt.format((cents || 0) / 100);

  const numericId = (gid) => String(gid).split('/').pop();

  const debounce = (fn, ms) => {
    let t;
    return (...a) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...a), ms);
    };
  };

  function splitField(path) {
    if (!path || !path.includes('.')) return null;
    const i = path.indexOf('.');
    return { namespace: path.slice(0, i).trim(), key: path.slice(i + 1).trim() };
  }

  // ---------------------------------------------------------------------------------------------
  // Storefront API: Index laden
  // ---------------------------------------------------------------------------------------------
  const FIELD_KEYS = Object.keys(CFG.fields || {});
  const IDENTIFIERS = FIELD_KEYS.map((k) => splitField(CFG.fields[k])).filter(Boolean);

  const INDEX_QUERY = `
    query KioskIndex($query: String!, $after: String, $ids: [HasMetafieldsIdentifier!]!, $withDesc: Boolean!) {
      products(first: 250, after: $after, query: $query, sortKey: CREATED_AT, reverse: true) {
        pageInfo { hasNextPage endCursor }
        nodes {
          id
          title
          handle
          createdAt
          description(truncateAt: 300) @include(if: $withDesc)
          featuredImage { url(transform: { maxWidth: 480 }) }
          metafields(identifiers: $ids) { namespace key value }
          variants(first: 30) {
            nodes {
              id
              title
              sku
              availableForSale
              quantityAvailable
              price { amount }
              selectedOptions { name value }
              image { url(transform: { maxWidth: 480 }) }
              metafields(identifiers: $ids) { namespace key value }
            }
          }
        }
      }
    }`;

  async function gql(query, variables) {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.token,
      },
      body: JSON.stringify({ query, variables }),
    });
    if (!res.ok) throw new Error(`Storefront API ${res.status}`);
    const json = await res.json();
    if (json.errors) throw new Error(json.errors.map((e) => e.message).join('; '));
    return json.data;
  }

  function metaMap(list) {
    const out = {};
    (list || []).forEach((m) => {
      if (m && m.value != null && m.value !== '') out[`${m.namespace}.${m.key}`] = m.value;
    });
    return out;
  }

  // Titel zerlegen: "<Name> [(V.x)] <SET>-<NR> <Seltenheit> <Zustand> <Sprache> [Foil]"
  // auch One-Piece-Stil: "<Name> (<SET>-<NR>) (V.x) <SET> <Seltenheit> <Zustand> <Sprache>"
  const SET_TOKEN = /(?:^|\s)\(?([A-Z0-9]{1,6}(?:-[A-Z]{1,3})?)-([A-Z]{0,3}\d{1,5}[A-Za-z]?)\)?(?=\s|$)/g;
  function parseTitle(title) {
    const out = { name: title, version: '', setCode: '', number: '', rarity: '', cond: '', lang: '', foil: false, reverse: false, firstEd: false };
    let m;
    let last = null;
    SET_TOKEN.lastIndex = 0;
    while ((m = SET_TOKEN.exec(title))) last = { index: m.index, len: m[0].length, set: m[1], nr: m[2] };
    let rest = title;
    if (last) {
      out.name = title.slice(0, last.index).trim();
      out.setCode = last.set;
      out.number = last.nr;
      rest = title.slice(last.index + last.len).trim();
      const rv = rest.match(/^\((V\.\s*\d+[^)]*)\)\s*/i);
      if (rv) {
        out.version = rv[1];
        rest = rest.slice(rv[0].length);
      }
      if (rest.split(' ')[0] === last.set) rest = rest.slice(last.set.length).trim();
    }
    // Version "(V.3)" am Namen
    const v = out.name.match(/\s*\((V\.\s*\d+[^)]*)\)\s*$/i);
    if (v) {
      out.version = v[1];
      out.name = out.name.slice(0, v.index).trim();
    }
    // Positionen immer im unveränderten Rest suchen (lower[i+1] entspricht rest[i])
    const lower = ' ' + rest.toLowerCase() + ' ';
    if (/\sreverse[ -]?holo\s/.test(lower)) out.reverse = true;
    if (/\s(1st edition|first edition|1\. auflage|erstauflage)\s/.test(lower)) out.firstEd = true;
    if (/\sfoil\s/.test(lower)) out.foil = true; // "Holo" allein ist bei Pokémon Teil der Seltenheit (Holo Rare)
    let langWord = '';
    for (const l of LANGUAGES) {
      const w = l.words.find((word) => lower.includes(' ' + word + ' '));
      if (w) {
        out.lang = l.code;
        langWord = w;
        break;
      }
    }
    // längste Zustandsbezeichnung zuerst ("near mint" vor "mint", "light played" vor "played")
    let rarityEnd = -1;
    const condWords = CONDITIONS.flatMap((c) => c.words.map((w) => ({ w, code: c.code }))).sort((a, b) => b.w.length - a.w.length);
    for (const { w, code } of condWords) {
      const idx = lower.lastIndexOf(' ' + w + ' ');
      if (idx !== -1) {
        out.cond = code;
        rarityEnd = idx;
        break;
      }
    }
    if (last) {
      let rarity = rarityEnd >= 0 ? rest.slice(0, rarityEnd) : rest;
      rarity = rarity
        .replace(/\breverse[ -]?holo\b/gi, ' ')
        .replace(/\bfoil\b/gi, ' ')
        .replace(/\b(1st edition|first edition|erstauflage)\b/gi, ' ')
        .replace(/1\. auflage/gi, ' ');
      if (langWord) rarity = rarity.replace(new RegExp(langWord.replace(/[()]/g, '\\$&'), 'i'), ' ');
      out.rarity = rarity.replace(/\s+/g, ' ').trim();
    }
    return out;
  }

  function normalizeCondition(v) {
    if (!v) return '';
    const s = String(v).trim();
    const up = s.toUpperCase();
    if (COND_RANK[up] != null) return up;
    const low = s.toLowerCase();
    const hit = CONDITIONS.find((c) => c.words.includes(low));
    return hit ? hit.code : '';
  }

  function normalizeLanguage(v) {
    if (!v) return '';
    const s = String(v).trim();
    if (LANG_BY_ID[s]) return LANG_BY_ID[s].code;
    if (LANG_BY_CODE[s.toUpperCase()]) return s.toUpperCase();
    const low = s.toLowerCase();
    const hit = LANGUAGES.find((l) => l.words.includes(low) || l.label.toLowerCase() === low);
    return hit ? hit.code : '';
  }

  const truthy = (v) => /^(true|1|ja|yes|foil)$/i.test(String(v || '').trim());

  // Produkt (+Varianten) -> Angebote (eine Zeile je verfügbarer Variante)
  function productToOffers(p, rank) {
    const pMeta = metaMap(p.metafields);
    const parsed = parseTitle(p.title || '');
    const offers = [];
    const F = CFG.fields || {};
    for (const v of p.variants?.nodes || []) {
      if (!v.availableForSale) continue;
      const qty = v.quantityAvailable == null ? MAX_QTY_UNTRACKED : v.quantityAvailable;
      if (qty <= 0) continue;
      const vMeta = metaMap(v.metafields);
      const get = (field) => (F[field] ? vMeta[F[field]] ?? pMeta[F[field]] ?? '' : '');
      const opts = {};
      (v.selectedOptions || []).forEach((o) => {
        opts[o.name.toLowerCase()] = o.value;
      });

      const cond = normalizeCondition(get('condition')) || normalizeCondition(opts['zustand'] || opts['condition']) || parsed.cond;
      const lang = normalizeLanguage(get('language')) || normalizeLanguage(opts['sprache'] || opts['language']) || parsed.lang;
      const foilMeta = get('foil');
      const foil = foilMeta !== '' ? truthy(foilMeta) : /foil/i.test(opts['extras'] || opts['finish'] || '') || parsed.foil;
      const revMeta = get('reverseHolo');
      const reverse = revMeta !== '' ? truthy(revMeta) : /reverse/i.test(opts['extras'] || opts['finish'] || '') || parsed.reverse;
      const firstEdMeta = get('firstEd');
      const firstEd = firstEdMeta !== '' ? truthy(firstEdMeta) : /1st|first|1\. auflage/i.test(opts['edition'] || opts['auflage'] || '') || parsed.firstEd;
      const nameEn = String(get('nameEn') || '').trim();
      const nameDe = String(get('nameDe') || '').trim();
      const nameTitle = parsed.name;

      offers.push({
        id: numericId(v.id),
        title: p.title,
        rank, // Position in der Abrufreihenfolge (0 = zuletzt angelegt)
        created: p.createdAt ? Date.parse(p.createdAt) || 0 : 0,
        variantTitle: v.title && v.title !== 'Default Title' ? v.title : '',
        sku: String(v.sku || '').trim(),
        image: v.image?.url || p.featuredImage?.url || '',
        nameEn,
        nameDe,
        nameTitle,
        version: parsed.version,
        setCode: String(get('setCode') || parsed.setCode || '').trim(),
        setName: String(get('setName') || '').trim(),
        number: parsed.number,
        rarity: String(get('rarity') || parsed.rarity || '').trim(),
        idProduct: String(get('idProduct') || '').trim(),
        cond,
        lang,
        foil,
        reverse,
        firstEd, // 1. Auflage (cardmarket.isFirstEd = true), sonst unlimitiert
        price: Math.round(parseFloat(v.price?.amount || '0') * 100),
        qty,
        desc: CFG.includeDescription ? norm(p.description || '') : '',
      });
    }
    return offers;
  }

  async function fetchIndex(game, onProgress) {
    let query = `tag:${JSON.stringify(game.tag)} available_for_sale:true`;
    if (CFG.productType) query += ` product_type:${JSON.stringify(CFG.productType)}`;
    const vars = { query, after: null, ids: IDENTIFIERS, withDesc: !!CFG.includeDescription };
    const all = [];
    let products = 0;
    for (let guard = 0; guard < 400; guard++) {
      const data = await gql(INDEX_QUERY, vars);
      const conn = data.products;
      for (const p of conn.nodes) all.push(...productToOffers(p, products++));
      onProgress && onProgress(all, products, conn.pageInfo.hasNextPage);
      if (!conn.pageInfo.hasNextPage) break;
      vars.after = conn.pageInfo.endCursor;
    }
    return all;
  }

  // ---------------------------------------------------------------------------------------------
  // Cache (IndexedDB) – Fehler werden still ignoriert (Kiosk funktioniert dann ohne Cache)
  // ---------------------------------------------------------------------------------------------
  const DB_NAME = 'bb-kiosk';
  const CACHE_VERSION = 8; // erhöhen, wenn sich das Angebotsformat ändert
  function idb() {
    return new Promise((resolve, reject) => {
      if (!('indexedDB' in window)) return reject(new Error('no idb'));
      const req = indexedDB.open(DB_NAME, 1);
      req.onupgradeneeded = () => req.result.createObjectStore('index');
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  }
  async function cacheGet(key) {
    try {
      const db = await idb();
      return await new Promise((resolve) => {
        const r = db.transaction('index').objectStore('index').get(key);
        r.onsuccess = () => resolve(r.result && r.result.v === CACHE_VERSION ? r.result : null);
        r.onerror = () => resolve(null);
      });
    } catch (e) {
      return null;
    }
  }
  async function cacheSet(key, offers) {
    try {
      const db = await idb();
      db.transaction('index', 'readwrite').objectStore('index').put({ v: CACHE_VERSION, ts: Date.now(), offers }, key);
    } catch (e) {
      /* egal */
    }
  }
  const cacheKey = (game) => `${game.tag}|${CFG.productType || ''}|${JSON.stringify(CFG.fields)}|${CFG.includeDescription ? 1 : 0}`;

  // ---------------------------------------------------------------------------------------------
  // Warenkorb (Ajax Cart API)
  // ---------------------------------------------------------------------------------------------
  const root = window.Shopify?.routes?.root || '/';
  async function cartAdd(id, quantity) {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || T('add_failed'));
    return data;
  }
  async function cartGet() {
    const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
    return res.json();
  }
  async function cartClear() {
    await fetch(root + 'cart/clear.js', { method: 'POST' });
  }
  function refreshThemeCart() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }
  // Theme-Warenkorb (Impact: <cart-drawer>) – gibt es keinen (z. B. Empire), öffnet der Kiosk seinen eigenen
  function openThemeCart() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') drawer.show();
    else openKxCart();
  }
  function closeAnyCart() {
    document.querySelector('cart-drawer')?.hide?.();
    closeKxCart();
  }

  // ---------------------------------------------------------------------------------------------
  // Eigener Kiosk-Warenkorb (Seitenleiste) – für Themes ohne Cart-Drawer
  // ---------------------------------------------------------------------------------------------
  let kxCart = null;
  function kxCartEl() {
    if (kxCart) return kxCart;
    kxCart = document.createElement('div');
    kxCart.className = 'kx kx-cartdrawer';
    kxCart.hidden = true;
    kxCart.innerHTML = `
      <div class="kx-cartdrawer-overlay" data-cart-action="close"></div>
      <aside class="kx-cartdrawer-panel" role="dialog" aria-modal="true" aria-label="${esc(T('cart_title'))}">
        <header class="kx-cartdrawer-head">
          <h2>${esc(T('cart_title'))}</h2>
          <button type="button" class="kx-side-close" data-cart-action="close" aria-label="${esc(T('cart_close'))}">×</button>
        </header>
        <div class="kx-cartdrawer-body" data-ref="kxcart-body"></div>
        <footer class="kx-cartdrawer-foot" data-ref="kxcart-foot"></footer>
      </aside>`;
    document.body.appendChild(kxCart);
    kxCart.addEventListener('click', onKxCartClick);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !kxCart.hidden) closeKxCart();
    });
    return kxCart;
  }
  async function openKxCart() {
    const el = kxCartEl();
    el.hidden = false;
    document.documentElement.classList.add('kx-cart-open');
    requestAnimationFrame(() => el.classList.add('is-open'));
    await renderKxCart();
  }
  function closeKxCart() {
    if (!kxCart || kxCart.hidden) return;
    kxCart.classList.remove('is-open');
    document.documentElement.classList.remove('kx-cart-open');
    setTimeout(() => (kxCart.hidden = true), 200);
  }
  async function renderKxCart(cart) {
    const el = kxCartEl();
    const body = el.querySelector('[data-ref="kxcart-body"]');
    const foot = el.querySelector('[data-ref="kxcart-foot"]');
    if (!cart) {
      try {
        cart = await cartGet();
      } catch (e) {
        body.innerHTML = `<p class="kx-empty">${esc(T('add_failed'))}</p>`;
        return;
      }
    }
    state.cart.count = cart.item_count || 0;
    state.cart.total = cart.total_price || 0;
    renderCart();
    if (!cart.items || !cart.items.length) {
      body.innerHTML = `<p class="kx-empty">${esc(T('cart_empty'))}</p>`;
      foot.innerHTML = `<button type="button" class="kx-btn kx-btn--ghost kx-btn--block" data-cart-action="close">${esc(T('continue_shopping'))}</button>`;
      return;
    }
    body.innerHTML = cart.items
      .map((it) => {
        const img = it.featured_image?.url || it.image;
        const variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        return `<div class="kx-cartline" data-key="${esc(it.key)}">
          <div class="kx-cartline-img">${img ? `<img src="${esc(img)}${img.includes('?') ? '&' : '?'}width=160" alt="" loading="lazy">` : ''}</div>
          <div class="kx-cartline-info">
            <div class="kx-cartline-title">${esc(it.product_title)}</div>
            ${variant ? `<div class="kx-muted kx-small">${esc(variant)}</div>` : ''}
            ${it.sku ? `<div class="kx-muted kx-small">${esc(it.sku)}</div>` : ''}
            <div class="kx-cartline-row">
              <div class="kx-stepper">
                <button type="button" data-cart-action="qty" data-qty="${it.quantity - 1}" aria-label="${esc(T('qty_less'))}">−</button>
                <span>${it.quantity}</span>
                <button type="button" data-cart-action="qty" data-qty="${it.quantity + 1}" aria-label="${esc(T('qty_more'))}">+</button>
              </div>
              <strong>${money(it.final_line_price)}</strong>
            </div>
          </div>
          <button type="button" class="kx-cartline-remove" data-cart-action="qty" data-qty="0" aria-label="${esc(T('cart_remove'))}">×</button>
        </div>`;
      })
      .join('');
    foot.innerHTML = `
      <div class="kx-cartdrawer-total"><span>${esc(T('cart_subtotal'))}</span><strong>${money(cart.total_price)}</strong></div>
      <p class="kx-muted kx-small">${esc(T('cart_tax_note'))}</p>
      <button type="button" class="kx-checkout kx-btn--block" data-cart-action="checkout">${esc(T('checkout'))}</button>
      <div class="kx-cartdrawer-links">
        <button type="button" class="kx-linkbtn" data-cart-action="close">${esc(T('continue_shopping'))}</button>
        <button type="button" class="kx-linkbtn" data-cart-action="clear">${esc(T('cart_clear'))}</button>
      </div>`;
  }
  async function onKxCartClick(e) {
    const btn = e.target.closest('[data-cart-action]');
    if (!btn) return;
    const action = btn.dataset.cartAction;
    if (action === 'close') return closeKxCart();
    if (action === 'checkout') {
      window.location.href = root + 'checkout';
      return;
    }
    btn.disabled = true;
    try {
      if (action === 'clear') {
        await cartClear();
        await renderKxCart();
      } else if (action === 'qty') {
        const key = btn.closest('[data-key]')?.dataset.key;
        const res = await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: Math.max(0, Number(btn.dataset.qty)) }),
        });
        const cart = await res.json();
        if (!res.ok) toast(cart.description || cart.message || T('add_failed'), 'error');
        await renderKxCart(res.ok ? cart : undefined);
      }
    } finally {
      btn.disabled = false;
    }
  }

  // ---------------------------------------------------------------------------------------------
  // Zustand
  // ---------------------------------------------------------------------------------------------
  const emptyFilters = () => ({
    q: '',
    exactKey: '',
    sets: new Set(),
    rarities: new Set(),
    langs: new Set(),
    minCond: '',
    foil: 'any',
    firstEd: 'any', // 'yes' = nur 1. Auflage, 'no' = nur unlimitiert
    priceMin: '',
    priceMax: '',
    sort: DECK ? 'deck' : 'new',
  });

  const state = {
    game: null,
    offers: [],
    groups: new Map(), // key -> Gruppe (alle Angebote des Spiels)
    loading: false,
    loadedProducts: 0,
    loadError: '',
    filters: emptyFilters(),
    page: 1,
    sidebarOpen: false,
    setSearch: '',
    cart: { count: 0, total: 0 },
    qty: {}, // Angebot-ID -> gewählte Menge
    expanded: new Set(), // Gruppen mit allen Versionen aufgeklappt
    facetOpen: new Set(), // Filterlisten mit allen Einträgen aufgeklappt
    // Decklisten-Import
    deck: { text: '', lines: [], unparsed: [], searched: false, searching: false, done: 0, editing: true, picks: new Map() },
  };

  const groupKeyOf = (o) => o._gk || norm(o.nameEn || o.nameTitle || o.title);

  function buildGroups(offers) {
    // Namensabgleich: Kennt eine Version beide Namen (Metafeld name_en + deutscher Titel), werden auch
    // Versionen ohne Metafeld (nur deutscher Titel) derselben Karte zugeordnet.
    const alias = new Map();
    for (const o of offers) {
      if (!o.nameEn) continue;
      const key = norm(o.nameEn);
      [o.nameTitle, o.nameDe].forEach((n) => {
        const a = norm(n);
        if (a && !alias.has(a)) alias.set(a, key);
      });
    }
    const groups = new Map();
    for (const o of offers) {
      const own = norm(o.nameEn || o.nameTitle || o.title);
      o._gk = o.nameEn ? own : alias.get(own) || alias.get(norm(o.nameDe)) || own;
      const key = o._gk;
      let g = groups.get(key);
      if (!g) {
        g = { key, nameEn: '', names: new Set(), image: '', offers: [], search: '' };
        groups.set(key, g);
      }
      g.offers.push(o);
      if (o.nameEn && !g.nameEn) g.nameEn = o.nameEn;
      [o.nameTitle, o.nameDe].forEach((n) => n && g.names.add(n));
      if (!g.image && o.image) g.image = o.image;
    }
    for (const g of groups.values()) {
      g.display = g.nameEn || [...g.names][0] || g.offers[0].title;
      g.alt = [...g.names].filter((n) => n && !norm(g.display).includes(norm(n)));
      g.search = norm([g.display, ...g.alt].join(' '));
      // Bild bevorzugt von deutscher bzw. englischer Version
      const pref = g.offers.find((o) => o.image && o.lang === 'DE') || g.offers.find((o) => o.image && o.lang === 'EN');
      if (pref) g.image = pref.image;
    }
    return groups;
  }

  // ---------------------------------------------------------------------------------------------
  // Sonderausführung je Spiel: "foil" (cardmarket.isFoil), "reverse_holo" (cardmarket.isReverseHolo), "none"
  // ---------------------------------------------------------------------------------------------
  const specialMode = () => (state.game && state.game.special) || 'foil';
  const SPECIAL_LABEL = { foil: 'Foil', reverse_holo: 'Reverse Holo' };
  const isSpecial = (o) => (specialMode() === 'reverse_holo' ? !!o.reverse : specialMode() === 'foil' ? !!o.foil : false);

  // ---------------------------------------------------------------------------------------------
  // Filtern
  // ---------------------------------------------------------------------------------------------
  function queryTokens() {
    return norm(state.filters.q).split(' ').filter(Boolean);
  }

  function offerPasses(o, except, tokens) {
    const f = state.filters;
    if (f.exactKey) {
      if (groupKeyOf(o) !== f.exactKey) return false;
    } else if (tokens.length) {
      const hay = o._hay || (o._hay = norm(`${o.nameEn} ${o.nameDe} ${o.title} ${o.sku}`) + ' ' + o.desc);
      for (const t of tokens) if (!hay.includes(t)) return false;
    }
    if (except !== 'sets' && f.sets.size && !f.sets.has(o.setCode)) return false;
    if (except !== 'rarities' && f.rarities.size && !f.rarities.has(o.rarity)) return false;
    if (except !== 'langs' && f.langs.size && !f.langs.has(o.lang)) return false;
    if (f.minCond && o.cond && COND_RANK[o.cond] > COND_RANK[f.minCond]) return false;
    if (except !== 'foil' && f.foil === 'yes' && !isSpecial(o)) return false;
    if (except !== 'foil' && f.foil === 'no' && isSpecial(o)) return false;
    if (except !== 'firstEd' && state.game?.firstEd && f.firstEd === 'yes' && !o.firstEd) return false;
    if (except !== 'firstEd' && state.game?.firstEd && f.firstEd === 'no' && o.firstEd) return false;
    const pmin = parseFloat(String(f.priceMin).replace(',', '.'));
    const pmax = parseFloat(String(f.priceMax).replace(',', '.'));
    if (!isNaN(pmin) && o.price < pmin * 100) return false;
    if (!isNaN(pmax) && o.price > pmax * 100) return false;
    return true;
  }

  function computeResults() {
    const tokens = queryTokens();
    const visible = new Map();
    const facets = { sets: new Map(), rarities: new Map(), langs: new Map(), foil: new Map(), firstEd: new Map() };
    const setNames = new Map();

    for (const o of state.offers) {
      const passAll = offerPasses(o, null, tokens);
      if (passAll) {
        const key = groupKeyOf(o);
        let g = visible.get(key);
        if (!g) visible.set(key, (g = { group: state.groups.get(key), offers: [] }));
        g.offers.push(o);
      }
      // Facetten-Zählung: jeweils ohne den eigenen Filter
      for (const facet of ['sets', 'rarities', 'langs']) {
        const val = facet === 'sets' ? o.setCode : facet === 'rarities' ? o.rarity : o.lang;
        if (!val) continue;
        if (passAll || offerPasses(o, facet, tokens)) facets[facet].set(val, (facets[facet].get(val) || 0) + 1);
      }
      // Ja/Nein-Filter (Foil bzw. Reverse Holo, 1. Auflage)
      if (passAll || offerPasses(o, 'foil', tokens)) {
        const v = isSpecial(o) ? 'yes' : 'no';
        facets.foil.set(v, (facets.foil.get(v) || 0) + 1);
      }
      if (passAll || offerPasses(o, 'firstEd', tokens)) {
        const v = o.firstEd ? 'yes' : 'no';
        facets.firstEd.set(v, (facets.firstEd.get(v) || 0) + 1);
      }
      if (o.setCode && o.setName && !setNames.has(o.setCode)) setNames.set(o.setCode, o.setName);
    }

    const list = [...visible.values()];
    for (const r of list) {
      r.offers.sort((a, b) => a.price - b.price || (COND_RANK[a.cond] ?? 9) - (COND_RANK[b.cond] ?? 9));
      r.minPrice = r.offers[0].price;
      r.firstRank = Math.min(...r.offers.map((o) => (o.rank == null ? Infinity : o.rank)));
    }
    const byName = (a, b) => a.group.display.localeCompare(b.group.display, LOCALE);
    const sorters = {
      name: byName,
      name_desc: (a, b) => -byName(a, b),
      price: (a, b) => a.minPrice - b.minPrice || byName(a, b),
      price_desc: (a, b) => b.minPrice - a.minPrice || byName(a, b),
      set: (a, b) => (a.offers[0].setCode || '').localeCompare(b.offers[0].setCode || '') || byName(a, b),
      // Reihenfolge des Abrufs: Karte steht dort, wo ihre neueste Version auftaucht
      new: (a, b) => a.firstRank - b.firstRank || byName(a, b),
    };
    list.sort(sorters[state.filters.sort] || byName);
    const offerCount = list.reduce((s, r) => s + r.offers.length, 0);
    return { list, facets, setNames, offerCount };
  }

  function suggestions(q) {
    const n = norm(q);
    if (n.length < 2) return [];
    const starts = [];
    const contains = [];
    for (const g of state.groups.values()) {
      const names = [g.display, ...g.alt];
      const normed = names.map(norm);
      if (normed.some((x) => x.startsWith(n) || x.includes(' ' + n))) starts.push(g);
      else if (g.search.includes(n)) contains.push(g);
      if (starts.length >= 8) break;
    }
    return [...starts, ...contains].slice(0, 8);
  }

  // ---------------------------------------------------------------------------------------------
  // Rendering
  // ---------------------------------------------------------------------------------------------
  let lastResults = null;

  function renderShell() {
    if (DECK) return renderDeckShell();
    mount.innerHTML = `
      <header class="kx-top">
        <div class="kx-top-left">
          ${CFG.homeUrl ? `<a class="kx-logo" href="${esc(CFG.homeUrl)}" aria-label="${esc(T('home'))}">${
            CFG.logo ? `<img src="${esc(CFG.logo)}" alt="${esc(CFG.shopName || T('home'))}">` : esc(CFG.shopName || 'Start')
          }</a>` : ''}
          ${
            GAMES.length > 1 || !state.game
              ? `<div class="kx-gamepick">
            <button type="button" class="kx-gamepick-btn" data-action="toggle-games" aria-haspopup="true" aria-expanded="false">
              ${
                state.game
                  ? state.game.logo
                    ? `<img src="${esc(state.game.logo)}" alt="${esc(state.game.label)}">`
                    : `<span class="kx-gamepick-label">${esc(state.game.label)}</span>`
                  : `<span class="kx-gamepick-label">${esc(T('choose_game'))}</span>`
              }
              <svg class="kx-caret" viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>
            </button>
            <div class="kx-gamemenu" data-ref="gamemenu" hidden>
              ${GAMES.map(
                (g) => `<button type="button" class="kx-gamemenu-item${state.game && state.game.id === g.id ? ' is-active' : ''}" data-action="game" data-game="${esc(g.id)}">
                  ${g.logo ? `<img src="${esc(g.logo)}" alt="" loading="lazy">` : ''}<span>${esc(g.label)}</span>
                </button>`
              ).join('')}
            </div>
          </div>`
              : `<div class="kx-brand">${esc(state.game.label)}</div>`
          }
        </div>
        <div class="kx-top-actions">
          ${LANGS.length > 1 ? `<div class="kx-locale" role="group" aria-label="${esc(T('language_switch'))}">
            ${LANGS.map((l) => `<button type="button" class="kx-locale-btn${l.code === LOCALE ? ' is-active' : ''}" data-action="lang" data-lang="${esc(l.code)}" aria-pressed="${l.code === LOCALE}" lang="${esc(l.code)}" title="${esc(l.name || l.code)}">${flagFor(l.code)}<span>${esc(String(l.code).split('-')[0].toUpperCase())}</span></button>`).join('')}
          </div>` : ''}
          ${CFG.accountUrl ? `<a class="kx-account" href="${esc(CFG.accountUrl)}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6"/></svg>
            <span>${esc(CFG.loggedIn ? T('my_account') : T('login'))}</span>
          </a>` : ''}
          <button type="button" class="kx-cart" data-action="open-cart" ${state.cart.count ? '' : 'disabled'}>
            <span class="kx-cart-count" data-ref="cart-count">${state.cart.count}</span>
            <span data-ref="cart-total">${money(state.cart.total)}</span>
          </button>
          <button type="button" class="kx-checkout" data-action="checkout" ${state.cart.count ? '' : 'disabled'}><span class="kx-hide-xs">${esc(T('checkout'))}</span><span class="kx-only-xs">${esc(T('checkout_short'))}</span></button>
        </div>
      </header>

      ${state.game ? '' : `<nav class="kx-games kx-games--start" aria-label="${esc(T('choose_game'))}">
        <h1 class="kx-start-title">${esc(T('start_title'))}</h1>
        <div class="kx-games-row">
          ${GAMES.map(
            (g) => `
            <button type="button" class="kx-game${state.game && state.game.id === g.id ? ' is-active' : ''}" data-action="game" data-game="${esc(g.id)}" aria-pressed="${state.game && state.game.id === g.id}">
              ${g.logo ? `<img src="${esc(g.logo)}" alt="${esc(g.label)}" loading="lazy">` : `<span>${esc(g.label)}</span>`}
            </button>`
          ).join('')}
        </div>
      </nav>`}

      ${
        state.game
          ? `
      <div class="kx-layout${state.sidebarOpen ? ' is-sidebar-open' : ''}">
        <aside class="kx-sidebar" data-ref="sidebar" aria-label="${esc(T('filter'))}"></aside>
        <div class="kx-backdrop" data-action="close-sidebar"></div>
        <main class="kx-main">
          <div class="kx-searchbar">
            <div class="kx-search">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
              <input type="search" data-ref="q" placeholder="${esc(T('search_placeholder'))}" value="${esc(state.filters.q)}" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="search">
              <button type="button" class="kx-search-clear" data-action="clear-q" aria-label="${esc(T('search_clear'))}" ${state.filters.q ? '' : 'hidden'}>×</button>
              <ul class="kx-suggest" data-ref="suggest" role="listbox" hidden></ul>
            </div>
            <button type="button" class="kx-filter-toggle" data-action="open-sidebar">${esc(T('filter'))}</button>
          </div>
          <div data-ref="results"></div>
        </main>
      </div>`
          : ''
      }

      <div class="kx-zoom" data-ref="zoom" data-action="close-zoom" hidden><img alt=""></div>
      <div class="kx-toast" data-ref="toast" role="status" aria-live="polite"></div>
    `;
    if (state.game) {
      renderSidebar();
      renderResults();
    }
  }

  // Element, das zuletzt in der Filterleiste angetippt wurde (+ seine Bildschirmposition):
  // Nach dem Neuzeichnen wird die Leiste so verschoben, dass genau dieses Element an derselben Stelle bleibt.
  let sidebarAnchor = null;
  function anchorSelector(el) {
    const d = el.dataset;
    if (d.binary && el.matches('input')) return `input[data-binary="${d.binary}"][value="${d.value || el.value}"]`;
    if (d.facet && el.matches('input')) return `input[data-facet="${d.facet}"][value="${CSS.escape(el.value)}"]`;
    if (d.action === 'cond') return `[data-action="cond"][data-cond="${d.cond}"]`;
    if (d.action === 'facet-more') return `[data-action="facet-more"][data-facet="${d.facet}"]`;
    if (d.filter) return `[data-filter="${d.filter}"]`;
    if (d.ref === 'set-search') return '[data-ref="set-search"]';
    return null;
  }
  function rememberSidebarAnchor(target) {
    const side = mount.querySelector('[data-ref="sidebar"]');
    const el = target && target.closest && target.closest('input, button, select');
    if (!side || !el || !side.contains(el)) return;
    const sel = anchorSelector(el);
    if (sel) sidebarAnchor = { sel, top: el.getBoundingClientRect().top, at: Date.now() };
  }

  function renderSidebar() {
    const el = mount.querySelector('[data-ref="sidebar"]');
    if (!el) return;
    const keepScroll = el.scrollTop;
    const r = lastResults || computeResults();
    const f = state.filters;

    // Stabile Listen: Reihenfolge hängt nur vom gesamten Sortiment des Spiels ab (nicht vom aktuellen Ergebnis),
    // Werte ohne Treffer bleiben ausgegraut stehen. So ändert ein Filter nicht die Höhe/Position der Liste.
    // Keine eigenen Scrollbereiche (auf Touch fangen die das Wischen ab): erste FACET_LIMIT + "Alle anzeigen".
    const FACET_LIMIT = 8;
    const facetList = (facet, entries, labelFn, forceAll = false) => {
      if (!entries.length) return '<p class="kx-muted">–</p>';
      const open = forceAll || state.facetOpen.has(facet);
      let shown = open ? entries : entries.slice(0, FACET_LIMIT);
      if (!open) {
        const extra = entries.slice(FACET_LIMIT).filter(([v]) => f[facet].has(v)); // gewählte Werte nie verstecken
        shown = shown.concat(extra);
      }
      const more =
        entries.length > FACET_LIMIT && !forceAll
          ? `<button type="button" class="kx-facet-more" data-action="facet-more" data-facet="${facet}">${
              esc(open ? T('show_less') : T('show_all', { n: entries.length }))
            }</button>`
          : '';
      return (
        shown
          .map(([val, count]) => {
            const checked = f[facet].has(val);
            const empty = !count && !checked;
            return `<label class="kx-check${checked ? ' is-checked' : ''}${empty ? ' is-empty' : ''}">
            <input type="checkbox" data-facet="${facet}" value="${esc(val)}" ${checked ? 'checked' : ''} ${empty ? 'disabled' : ''}>
            <span class="kx-check-label">${labelFn(val)}</span><span class="kx-count">${count || 0}</span>
          </label>`;
          })
          .join('') + more
      );
    };

    // Ja/Nein-Filter als Häkchen-Liste: kein Haken = egal; ein Haken = nur diese Ausprägung
    const binaryList = (key, rows) =>
      rows
        .map(([val, label]) => {
          const count = r.facets[key].get(val) || 0;
          const checked = f[key] === val;
          const empty = !count && !checked;
          return `<label class="kx-check${checked ? ' is-checked' : ''}${empty ? ' is-empty' : ''}">
            <input type="checkbox" data-binary="${key}" value="${val}" ${checked ? 'checked' : ''} ${empty ? 'disabled' : ''}>
            <span class="kx-check-label">${label}</span><span class="kx-count">${count}</span>
          </label>`;
        })
        .join('');

    // Basis: alle Werte des Spiels in fester Reihenfolge, Zahlen aus dem aktuellen Ergebnis
    const base = state.facetBase || { sets: [], rarities: [], langs: [] };
    const withCounts = (facet) => base[facet].map((v) => [v, r.facets[facet].get(v) || 0]);

    const setSearch = norm(state.setSearch);
    const sets = withCounts('sets').filter(([code]) => !setSearch || norm(`${code} ${r.setNames.get(code) || ''}`).includes(setSearch));
    const rarities = withCounts('rarities');
    const langs = withCounts('langs');

    // Position halten: angetipptes Element an derselben Bildschirmstelle, sonst bisherige Scrollposition
    requestAnimationFrame(() => {
      const a = sidebarAnchor && Date.now() - sidebarAnchor.at < 3000 ? sidebarAnchor : null;
      const now = a && el.querySelector(a.sel);
      el.scrollTop = keepScroll;
      if (now) el.scrollTop += now.getBoundingClientRect().top - a.top;
    });

    el.innerHTML = `
      <div class="kx-side-head">
        <h2>${esc(T('filter'))}</h2>
        <button type="button" class="kx-side-close" data-action="close-sidebar" aria-label="${esc(T('close_filters'))}">×</button>
      </div>

      <section class="kx-fbox">
        <h3>${esc(T('sort'))}</h3>
        <select data-filter="sort">
          ${SORTS.map((s) => `<option value="${s.id}" ${f.sort === s.id ? 'selected' : ''}>${s.label}</option>`).join('')}
        </select>
      </section>

      <section class="kx-fbox">
        <h3>${esc(T('price'))}</h3>
        <div class="kx-price">
          <label><span>${esc(T('price_min'))}</span><input type="text" inputmode="decimal" data-filter="priceMin" value="${esc(f.priceMin)}" placeholder="0"><span>€</span></label>
          <label><span>${esc(T('price_max'))}</span><input type="text" inputmode="decimal" data-filter="priceMax" value="${esc(f.priceMax)}" placeholder="∞"><span>€</span></label>
        </div>
      </section>

      <section class="kx-fbox">
        <h3>${esc(T('set'))} ${f.sets.size ? `<span class="kx-badge">${f.sets.size}</span>` : ''}</h3>
        <input type="search" class="kx-set-search" data-ref="set-search" placeholder="${esc(T('set_search'))}" value="${esc(state.setSearch)}">
        <div class="kx-checklist">${facetList(
          'sets',
          sets,
          (c) => `<b>${esc(c)}</b>${r.setNames.get(c) ? ` <span class="kx-muted">${esc(r.setNames.get(c))}</span>` : ''}`,
          !!setSearch
        )}</div>
      </section>

      <section class="kx-fbox">
        <h3>${esc(T('rarity'))} ${f.rarities.size ? `<span class="kx-badge">${f.rarities.size}</span>` : ''}</h3>
        <div class="kx-checklist">${facetList('rarities', rarities, (v) => esc(v))}</div>
      </section>

      <section class="kx-fbox">
        <h3>${esc(T('min_condition'))}</h3>
        <div class="kx-chips">
          ${CONDITIONS.filter((c) => c.code !== 'MT' && c.code !== 'PO').map(
            (c) =>
              `<button type="button" class="kx-chip kx-cond kx-cond--${c.code}${f.minCond === c.code ? ' is-active' : ''}" data-action="cond" data-cond="${c.code}" data-cond-tip="${c.code}">${c.code}</button>`
          ).join('')}
          <button type="button" class="kx-chip${!f.minCond ? ' is-active' : ''}" data-action="cond" data-cond="" title="${esc(T('all_conditions'))}">${esc(T('all'))}</button>
        </div>
      </section>

      <section class="kx-fbox">
        <h3>${esc(T('language'))} ${f.langs.size ? `<span class="kx-badge">${f.langs.size}</span>` : ''}</h3>
        <div class="kx-checklist">${facetList('langs', langs, (code) =>
          `<span class="kx-lang">${esc(code)}</span> ${esc(langName(code))}`
        )}</div>
      </section>

      ${state.game.foilFilter === false || specialMode() === 'none' ? '' : `<section class="kx-fbox">
        <h3>${SPECIAL_LABEL[specialMode()]}</h3>
        <div class="kx-checklist">${binaryList('foil', [
          ['yes', `<span class="kx-foil">${SPECIAL_LABEL[specialMode()]}</span>`],
          ['no', esc(specialMode() === 'foil' ? T('non_foil') : T('without', { x: SPECIAL_LABEL[specialMode()] }))],
        ])}</div>
      </section>`}

      ${state.game.firstEd ? `<section class="kx-fbox">
        <h3>${esc(T('edition'))}</h3>
        <div class="kx-checklist">${binaryList('firstEd', [
          ['yes', `<span class="kx-first" aria-hidden="true">1</span> ${esc(T('first_edition'))}`],
          ['no', esc(T('unlimited'))],
        ])}</div>
      </section>` : ''}


      <div class="kx-side-actions">
        <button type="button" class="kx-btn kx-btn--ghost" data-action="reset-filters">${esc(T('reset'))}</button>
        <button type="button" class="kx-btn kx-btn--primary kx-only-mobile" data-action="close-sidebar">${esc(r.list.length === 1 ? T('show_card') : T('show_cards', { n: r.list.length.toLocaleString(LOCALE) }))}</button>
      </div>
    `;
  }

  function conditionBadge(code) {
    if (!code) return '';
    return `<span class="kx-cond kx-cond--${code}" data-cond-tip="${code}" tabindex="0">${esc(code)}</span>`;
  }

  function renderOffer(o) {
    const pick = DECK ? state.deck.picks.get(o.id) || 0 : 0;
    const sel = Math.min(state.qty[o.id] || pick || 1, o.qty);
    return `
      <div class="kx-offer${o.qty > 1 ? ' kx-offer--multi' : ''}${pick ? ' is-pick' : ''}" data-offer="${esc(o.id)}">
        <div class="kx-offer-main">
          <div class="kx-offer-tags">
            ${conditionBadge(o.cond)}
            ${o.lang ? `<span class="kx-lang" title="${esc(langName(o.lang))}">${esc(o.lang)}</span>` : ''}
            ${isSpecial(o) ? `<span class="kx-foil">${SPECIAL_LABEL[specialMode()]}</span>` : ''}
            ${state.game?.firstEd && o.firstEd ? `<span class="kx-first" title="${esc(T('first_edition'))}" aria-label="${esc(T('first_edition'))}">1</span>` : ''}
            ${pick ? `<span class="kx-pick">${esc(T('deck_pick', { n: pick }))}</span>` : ''}
          </div>
        </div>
        <div class="kx-offer-buy">
          <div class="kx-offer-info">
            <div class="kx-offer-price">${money(o.price)}</div>
            <div class="kx-offer-stock">${esc(o.qty >= MAX_QTY_UNTRACKED ? T('available') : T('available_n', { n: o.qty }))}</div>
            ${o.sku ? `<div class="kx-offer-sku" title="Artikelnummer">${esc(o.sku)}</div>` : ''}
          </div>
          <div class="kx-stepper" ${o.qty <= 1 ? 'hidden' : ''}>
            <button type="button" data-action="qty" data-delta="-1" aria-label="${esc(T('qty_less'))}" ${sel <= 1 ? 'disabled' : ''}>−</button>
            <span data-ref="qty">${sel}</span>
            <button type="button" data-action="qty" data-delta="1" aria-label="${esc(T('qty_more'))}" ${sel >= o.qty ? 'disabled' : ''}>+</button>
          </div>
          <button type="button" class="kx-add" data-action="add" aria-label="${esc(T('add_to_cart'))}">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6.2"/><circle cx="10" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/></svg>
          </button>
        </div>
      </div>`;
  }

  // Print einer Karte: eigene cardmarket.idProduct (= eigenes Kartenbild).
  // Ohne idProduct: Set + Nummer + Version aus dem Titel.
  const printKeyOf = (o) => (o.idProduct ? `id:${o.idProduct}` : `p:${o.setCode}|${o.number}|${o.version}`);

  function splitPrintings(offers) {
    const map = new Map();
    for (const o of offers) {
      const k = printKeyOf(o);
      let p = map.get(k);
      if (!p) map.set(k, (p = { key: k, offers: [], image: '' }));
      p.offers.push(o);
    }
    const list = [...map.values()];
    for (const p of list) {
      p.offers.sort((a, b) => a.price - b.price || (COND_RANK[a.cond] ?? 9) - (COND_RANK[b.cond] ?? 9));
      const ref = p.offers.find((o) => o.image && o.lang === 'DE') || p.offers.find((o) => o.image && o.lang === 'EN') || p.offers.find((o) => o.image);
      p.image = ref ? ref.image : '';
      p.ref = p.offers[0];
      p.minPrice = p.offers[0].price;
    }
    return list.sort((a, b) => a.minPrice - b.minPrice);
  }

  function renderPrinting(p, g, offers) {
    const o = p.ref;
    const meta = [o.setName && o.setName !== o.setCode ? o.setName : '', o.number && o.setCode ? `#${o.number}` : '', o.version].filter(Boolean).join(' · ');
    return `
      <section class="kx-print">
        <button type="button" class="kx-print-img" data-action="zoom" data-src="${esc(p.image)}" ${p.image ? '' : 'disabled'} aria-label="${esc(T('zoom'))}">
          ${p.image ? `<img src="${esc(p.image)}" alt="${esc(g.display)}${o.setCode ? ' – ' + esc(o.setCode) : ''}" loading="lazy">` : `<span class="kx-noimg">${esc(T('no_image'))}</span>`}
        </button>
        <div class="kx-print-body">
          <div class="kx-print-head">
            ${o.setCode ? `<span class="kx-set">${esc(o.setCode)}</span>` : ''}
            ${meta ? `<span class="kx-offer-meta">${esc(meta)}</span>` : ''}
            ${o.rarity ? `<span class="kx-rarity">${esc(o.rarity)}</span>` : ''}
          </div>
          <div class="kx-offers">${offers.map(renderOffer).join('')}</div>
          ${p.offers.length > offers.length ? `<div class="kx-print-more kx-muted">${esc(T(p.offers.length - offers.length === 1 ? 'more_version' : 'more_versions', { n: p.offers.length - offers.length }))}</div>` : ''}
        </div>
      </section>`;
  }

  function renderGroup(r) {
    const g = r.group;
    const printings = splitPrintings(r.offers);
    const open = state.expanded.has(g.key);

    // Eingeklappt: bis zu PRINTS_COLLAPSED Drucke (jeder mit Bild) mit je bis zu OFFERS_PER_PRINT günstigsten Angeboten
    const shown = (open ? printings : printings.slice(0, PRINTS_COLLAPSED)).map((p) => [p, open ? p.offers : p.offers.slice(0, OFFERS_PER_PRINT)]);
    const shownCount = shown.reduce((s, [, take]) => s + take.length, 0);

    return `
      <article class="kx-group" data-key="${esc(g.key)}">
        <header class="kx-group-head">
          <div>
            <h3 class="kx-group-name">${esc(g.display)}</h3>
            ${g.alt.length ? `<div class="kx-group-alt">${g.alt.map(esc).join(' · ')}</div>` : ''}
          </div>
          ${r.deckHead || ''}
        </header>
        <div class="kx-prints">${shown.map(([p, take]) => renderPrinting(p, g, take)).join('')}</div>
        ${
          open || shownCount < r.offers.length
            ? `<button type="button" class="kx-more" data-action="expand" data-key="${esc(g.key)}">${
                esc(open ? T('show_less') : printings.length === 1 ? T('all_versions_one_print', { n: r.offers.length }) : T('all_versions', { n: r.offers.length, p: printings.length }))
              }</button>`
            : ''
        }
      </article>`;
  }

  function pager(pages) {
    if (pages <= 1) return '';
    return `
      <div class="kx-pager">
        <button type="button" data-action="page" data-page="${state.page - 1}" ${state.page <= 1 ? 'disabled' : ''} aria-label="${esc(T('prev_page'))}">‹</button>
        <span><span class="kx-hide-xs">${esc(T('page_of', { p: state.page, n: pages }))}</span><span class="kx-only-xs">${state.page}/${pages}</span></span>
        <button type="button" data-action="page" data-page="${state.page + 1}" ${state.page >= pages ? 'disabled' : ''} aria-label="${esc(T('next_page'))}">›</button>
      </div>`;
  }

  function activeChips() {
    const f = state.filters;
    const chips = [];
    if (f.exactKey) chips.push(['exact', '', `„${state.groups.get(f.exactKey)?.display || f.q}“`]);
    f.sets.forEach((v) => chips.push(['sets', v, T('set_chip', { x: v })]));
    f.rarities.forEach((v) => chips.push(['rarities', v, v]));
    f.langs.forEach((v) => chips.push(['langs', v, langName(v)]));
    if (f.minCond) chips.push(['minCond', '', T('condition_from', { x: COND_LABEL[f.minCond] })]);
    if (f.foil !== 'any') chips.push(['foil', '', T(f.foil === 'yes' ? 'only' : 'without', { x: SPECIAL_LABEL[specialMode()] || 'Foil' })]);
    if (f.firstEd !== 'any') chips.push(['firstEd', '', f.firstEd === 'yes' ? T('first_edition') : T('unlimited')]);
    if (f.priceMin) chips.push(['priceMin', '', T('price_from', { x: f.priceMin })]);
    if (f.priceMax) chips.push(['priceMax', '', T('price_to', { x: f.priceMax })]);
    // Immer vorhanden (auch leer) und einzeilig in der Ergebniszeile -> keine Verschiebung des Kartenrasters
    return `<div class="kx-active" data-ref="chips" aria-label="${esc(T('active_filters'))}">${chips
      .map(
        ([k, v, l]) =>
          `<button type="button" class="kx-active-chip" data-action="remove-filter" data-key="${k}" data-value="${esc(v)}"><span>${esc(l)}</span><span class="kx-active-x" aria-hidden="true">×</span></button>`
      )
      .join('')}</div>`;
  }

  function summaryHtml(r) {
    return `<b>${r.list.length.toLocaleString(LOCALE)}</b> ${esc(T('cards'))} · ${r.offerCount.toLocaleString(LOCALE)} ${esc(T('versions'))}${
      state.loading
        ? ` <span class="kx-loading-inline"><span class="kx-spinner"></span>${esc(T('loading_inline', { n: state.loadedProducts.toLocaleString(LOCALE) }))}</span>`
        : ''
    }`;
  }

  // Während des Nachladens: nur Zähler und Seitenzahl aktualisieren, sichtbare Karten nicht anfassen
  function renderResultsLight() {
    if (DECK) return renderDeckResults();
    const el = mount.querySelector('[data-ref="results"]');
    if (!el) return;
    lastResults = computeResults();
    const r = lastResults;
    const pages = Math.max(1, Math.ceil(r.list.length / PAGE_SIZE));
    const s = el.querySelector('[data-ref="summary"]');
    if (s) s.innerHTML = summaryHtml(r);
    el.querySelectorAll('[data-ref="pager-top"], [data-ref="pager-bottom"]').forEach((p) => (p.innerHTML = pager(pages)));
  }

  // Erste (teilweise) sichtbare Karte merken und nach dem Neuzeichnen wieder an dieselbe Stelle setzen
  function captureResultsAnchor() {
    const topBar = DECK ? stickyOffset() : (mount.querySelector('.kx-top')?.offsetHeight || 0) + (mount.querySelector('.kx-searchbar')?.offsetHeight || 0);
    for (const a of mount.querySelectorAll('.kx-group[data-key]')) {
      const rect = a.getBoundingClientRect();
      if (rect.bottom > topBar + 8) return { key: a.dataset.key, top: rect.top };
    }
    return null;
  }
  function restoreResultsAnchor(anchor) {
    if (!anchor) return;
    const el = [...mount.querySelectorAll('.kx-group[data-key]')].find((a) => a.dataset.key === anchor.key);
    if (el) window.scrollBy(0, el.getBoundingClientRect().top - anchor.top);
  }

  function renderResults() {
    if (DECK) return renderDeckResults();
    const el = mount.querySelector('[data-ref="results"]');
    if (!el) return;
    lastResults = computeResults();
    const r = lastResults;
    const pages = Math.max(1, Math.ceil(r.list.length / PAGE_SIZE));
    if (state.page > pages) state.page = pages;
    const slice = r.list.slice((state.page - 1) * PAGE_SIZE, state.page * PAGE_SIZE);

    const loadingBody = `<div class="kx-empty"><div class="kx-spinner kx-spinner--lg"></div>${esc(T('loading_game', { game: state.game.label }))}</div>`;

    let body;
    if (state.loadError && !state.offers.length) {
      body = `<div class="kx-empty">${esc(T('load_error'))}<br><small>${esc(state.loadError)}</small>
        <br><button type="button" class="kx-btn kx-btn--primary" data-action="reload">${esc(T('retry'))}</button></div>`;
    } else if (!r.list.length && state.loading) {
      body = loadingBody;
    } else if (!r.list.length && !state.loading) {
      body = `<div class="kx-empty">${esc(T('no_results'))}${
        hasActiveFilters() ? `<br><button type="button" class="kx-btn kx-btn--ghost" data-action="reset-filters">${esc(T('reset_filters'))}</button>` : ''
      }</div>`;
    } else {
      body = slice.map(renderGroup).join('');
    }

    el.innerHTML = `
      <div class="kx-resultbar">
        <span class="kx-summary" data-ref="summary">${summaryHtml(r)}</span>
        ${activeChips()}
        <span data-ref="pager-top">${pager(pages)}</span>
      </div>
      <div class="kx-groups">${body}</div>
      <div class="kx-resultbar kx-resultbar--bottom" data-ref="pager-bottom">${pager(pages)}</div>
    `;

    const filterBtn = mount.querySelector('.kx-filter-toggle');
    if (filterBtn) filterBtn.textContent = activeFilterCount() ? T('filter_count', { n: activeFilterCount() }) : T('filter');
  }

  function hasActiveFilters() {
    return activeFilterCount() > 0 || !!state.filters.q;
  }
  function activeFilterCount() {
    const f = state.filters;
    return f.sets.size + f.rarities.size + f.langs.size + (f.minCond ? 1 : 0) + (f.foil !== 'any' ? 1 : 0) + (f.firstEd !== 'any' ? 1 : 0) + (f.priceMin ? 1 : 0) + (f.priceMax ? 1 : 0);
  }

  function update({ sidebar = true, resetPage = true, toTop = false, keepAnchor = false } = {}) {
    if (resetPage) {
      state.page = 1;
      state.expanded = new Set();
    }
    const anchor = keepAnchor ? captureResultsAnchor() : null;
    renderResults();
    restoreResultsAnchor(anchor);
    if (sidebar) renderSidebar();
    if (toTop) scrollResultsTop();
  }

  // Nach einem Filter: Kartenliste wieder von oben zeigen (nur hochscrollen, nie nach unten springen)
  function scrollResultsTop() {
    const main = mount.querySelector('.kx-main');
    if (!main) return;
    const topBar = DECK ? stickyOffset() : mount.querySelector('.kx-top')?.offsetHeight || 0;
    const y = Math.max(0, main.getBoundingClientRect().top + window.scrollY - topBar - 12);
    if (window.scrollY > y) window.scrollTo({ top: y });
  }
  const applyFilter = (opts = {}) => update({ ...opts, toTop: true });

  function renderCart() {
    const c = mount.querySelector('[data-ref="cart-count"]');
    const t = mount.querySelector('[data-ref="cart-total"]');
    if (c) c.textContent = state.cart.count;
    if (t) t.textContent = money(state.cart.total);
    mount.querySelectorAll('[data-action="open-cart"],[data-action="checkout"]').forEach((b) => (b.disabled = !state.cart.count));
  }

  let toastTimer;
  function toast(msg, kind = 'ok') {
    const el = mount.querySelector('[data-ref="toast"]');
    if (!el) return;
    el.textContent = msg;
    el.className = `kx-toast is-visible kx-toast--${kind}`;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => (el.className = 'kx-toast'), 2600);
  }

  // ---------------------------------------------------------------------------------------------
  // Suche + Vorschläge
  // ---------------------------------------------------------------------------------------------
  const applySearch = debounce(() => applyFilter(), 220);

  function renderSuggest() {
    const list = mount.querySelector('[data-ref="suggest"]');
    if (!list) return;
    const items = state.filters.exactKey ? [] : suggestions(state.filters.q);
    if (!items.length) {
      list.hidden = true;
      list.innerHTML = '';
      return;
    }
    list.innerHTML = items
      .map(
        (g) => `<li role="option"><button type="button" data-action="suggest" data-key="${esc(g.key)}">
          ${g.image ? `<img src="${esc(g.image)}" alt="" loading="lazy">` : '<span class="kx-suggest-noimg"></span>'}
          <span><b>${esc(g.display)}</b>${g.alt.length ? `<small>${esc(g.alt.join(' · '))}</small>` : ''}</span>
          <span class="kx-muted">${g.offers.length}</span>
        </button></li>`
      )
      .join('');
    list.hidden = false;
  }
  function hideSuggest() {
    const list = mount.querySelector('[data-ref="suggest"]');
    if (list) list.hidden = true;
  }

  // ---------------------------------------------------------------------------------------------
  // Spiel laden
  // ---------------------------------------------------------------------------------------------
  let loadToken = 0;
  async function selectGame(game, { force = false } = {}) {
    const token = ++loadToken;
    if (!window.Shopify?.designMode) syncUrl(game);
    state.game = game;
    state.filters = emptyFilters();
    state.page = 1;
    state.qty = {};
    state.expanded = new Set();
    state.setSearch = '';
    state.loadError = '';
    state.offers = [];
    state.groups = new Map();
    lastResults = null;

    const key = cacheKey(game);
    const cached = force ? null : await cacheGet(key);
    if (token !== loadToken) return;
    if (cached) {
      setOffers(cached.offers);
      state.loadedAt = cached.ts;
      state.loading = false;
      renderShell();
      if (Date.now() - cached.ts < CACHE_MS) return;
      // veraltet: im Hintergrund neu laden, bisherige Daten bleiben sichtbar
      loadFresh(game, token, { background: true });
      return;
    }
    renderShell();
    loadFresh(game, token, { background: false });
  }

  function setOffers(offers) {
    state.offers = offers;
    state.groups = buildGroups(offers);
    // feste Reihenfolge der Filterwerte: Sets alphabetisch, Seltenheit/Sprache nach Häufigkeit im ganzen Sortiment
    const count = (key) => {
      const m = new Map();
      offers.forEach((o) => o[key] && m.set(o[key], (m.get(o[key]) || 0) + 1));
      return m;
    };
    const byFreq = (m) => [...m.entries()].sort((a, b) => b[1] - a[1] || String(a[0]).localeCompare(String(b[0]))).map(([v]) => v);
    state.facetBase = {
      sets: [...count('setCode').keys()].sort((a, b) => a.localeCompare(b)),
      rarities: byFreq(count('rarity')),
      langs: byFreq(count('lang')),
    };
  }

  async function loadFresh(game, token, { background }) {
    if (background && state.refreshing) return;
    state.refreshing = background;
    try {
      await loadFreshInner(game, token, { background });
    } finally {
      if (background) state.refreshing = false;
    }
  }
  async function loadFreshInner(game, token, { background }) {
    state.loading = !background;
    state.loadedProducts = 0;
    if (!background) renderResults();
    const progressive = debounce(() => {
      if (token !== loadToken || !state.loading) return;
      const shown = mount.querySelectorAll('.kx-group[data-key]').length;
      if (shown < PAGE_SIZE) update({ resetPage: false, keepAnchor: true });
      else renderResultsLight();
    }, 400);
    try {
      const offers = await fetchIndex(game, (partial, products) => {
        if (token !== loadToken) return;
        state.loadedProducts = products;
        if (!background) {
          setOffers(partial.slice());
          progressive();
        }
      });
      if (token !== loadToken) return;
      setOffers(offers);
      state.loadedAt = Date.now();
      state.loading = false;
      cacheSet(cacheKey(game), offers);
      update({ resetPage: false, keepAnchor: true }); // Seite + Position bleiben, auch nach Hintergrund-Aktualisierung
    } catch (err) {
      if (token !== loadToken) return;
      state.loading = false;
      state.loadError = err.message || String(err);
      if (!background) update();
      console.error('[bb-kiosk]', err);
    }
  }

  // =============================================================================================
  // DECKLISTEN-IMPORT (CFG.mode = 'deck')
  // Gleiche Oberfläche wie der Kiosk, aber eingebettet in eine normale Shopseite: Deckliste einfügen ->
  // je Zeile Suche über die Storefront API -> Ergebnisse als Karte › Print › Version mit Filtern links.
  // "Günstigste Auswahl" verteilt die gewünschte Menge je Karte auf die günstigsten Versionen, die zu den
  // aktuellen Filtern passen (z. B. nur Deutsch, ab EX).
  // =============================================================================================
  const DECK_QUERY = INDEX_QUERY.replace('sortKey: CREATED_AT, reverse: true', 'sortKey: RELEVANCE');
  const DECK_STORE = 'bb-deck-text';
  const DECK_PAGES = 4; // max. 4 × 250 Produkte je Kartenname
  const DECK_PARALLEL = 4;

  // Abstand oben: Höhe eines klebenden Theme-Headers (damit die Filterleiste nicht darunter verschwindet)
  function stickyOffset() {
    let max = 0;
    for (const el of document.querySelectorAll('header, sticky-header, .shopify-section-group-header-group, [data-sticky-header], .site-header')) {
      if (mount.contains(el)) continue;
      const cs = getComputedStyle(el);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      const r = el.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > max && r.height < 260) max = r.bottom;
    }
    return Math.round(max);
  }
  let stickyRaf = 0;
  function updateSticky() {
    cancelAnimationFrame(stickyRaf);
    stickyRaf = requestAnimationFrame(() => mount.style.setProperty('--kx-sticky', `${stickyOffset()}px`));
  }

  // "4 Lightning Bolt", "4x Lightning Bolt", "Lightning Bolt x4", "1 Sol Ring (CMM) 410 *F*", "3 Nami (OP01-016)"
  function parseDecklist(text) {
    const byKey = new Map();
    const unparsed = [];
    for (const raw of String(text || '').split(/\r?\n/)) {
      const t = raw.replace(/\t/g, ' ').replace(/\s+/g, ' ').trim();
      if (!t || /^(\/\/|#)/.test(t)) continue;
      let m = t.match(/^(\d{1,3})\s*[x×]?\s+(.+)$/i);
      let qty, name;
      if (m) [qty, name] = [parseInt(m[1], 10), m[2]];
      else if ((m = t.match(/^(.+?)\s+[x×]\s*(\d{1,3})$/i))) [qty, name] = [parseInt(m[2], 10), m[1]];
      else {
        // Abschnittsüberschriften ("Deck", "Sideboard", "Main Deck:", "Commander") still überspringen
        if (!/^(deck|main ?deck|main|sideboard|side ?deck|side|extra ?deck|extra|commander|companion|maybeboard|tokens?|sorcery|creatures?|lands?|spells?|instants?|artifacts?|enchantments?|planeswalkers?|monsters?|traps?|characters?|items?|locations?|leader|don)\b.*:?\s*(\(\d+\))?$/i.test(t)) unparsed.push(t);
        continue;
      }
      name = name
        .replace(/\s+\*[A-Z]+\*$/i, '')
        .replace(/\s+\[[^\]]+\]$/, '')
        .replace(/\s+\([A-Za-z0-9-]{2,12}\)(\s+[A-Za-z0-9-]+)?(\s+\*[A-Z]+\*)?$/, '')
        .trim();
      if (!name || !qty) {
        unparsed.push(t);
        continue;
      }
      const n = norm(name);
      const ex = byKey.get(n);
      if (ex) ex.qty += qty;
      else byKey.set(n, { name, n, qty });
    }
    return { lines: [...byKey.values()], unparsed };
  }

  // Namen einer Version (normalisiert), inkl. Vorderseite bei doppelseitigen Karten ("A // B")
  function nameKeys(o) {
    if (o._nk) return o._nk;
    const set = new Set();
    for (const v of [o.nameEn, o.nameDe, o.nameTitle]) {
      if (!v) continue;
      set.add(norm(v));
      if (v.includes('//')) set.add(norm(v.split('//')[0]));
    }
    set.delete('');
    return (o._nk = set);
  }

  async function fetchDeckLine(game, line) {
    const base = `tag:${JSON.stringify(game.tag)} available_for_sale:true${CFG.productType ? ` product_type:${JSON.stringify(CFG.productType)}` : ''}`;
    const clean = line.name.replace(/["():\\]/g, ' ').replace(/\s+/g, ' ').trim();
    const nameField = CFG.fields?.nameEn || 'singles.name_en';
    const queries = [`${base} metafield:${nameField}:${clean}`, `${base} ${JSON.stringify(clean)}`];
    for (const query of queries) {
      const found = [];
      const vars = { query, after: null, ids: IDENTIFIERS, withDesc: false };
      for (let page = 0; page < DECK_PAGES; page++) {
        const data = await gql(DECK_QUERY, vars);
        const conn = data.products;
        for (const p of conn.nodes) for (const o of productToOffers(p, 0)) if (nameKeys(o).has(line.n)) found.push(o);
        if (!conn.pageInfo.hasNextPage) break;
        vars.after = conn.pageInfo.endCursor;
      }
      if (found.length) return found;
    }
    return [];
  }

  async function searchDeck() {
    const ta = mount.querySelector('[data-ref="deck-text"]');
    const d = state.deck;
    d.text = ta ? ta.value : d.text;
    try {
      localStorage.setItem(DECK_STORE, d.text);
    } catch (e) {
      /* egal */
    }
    const { lines, unparsed } = parseDecklist(d.text);
    if (!lines.length) {
      toast(T('deck_empty'), 'error');
      return;
    }
    if (!CFG.token) {
      toast(T('boot_error'), 'error');
      return;
    }
    d.searching = true;
    d.done = 0;
    d.lines = lines;
    d.unparsed = unparsed;
    renderDeckProgress();
    const game = state.game;
    const all = new Map();
    let next = 0;
    let failed = '';
    const worker = async () => {
      while (next < lines.length) {
        const line = lines[next++];
        try {
          for (const o of await fetchDeckLine(game, line)) all.set(o.id, o);
        } catch (err) {
          failed = err.message || String(err);
        }
        d.done++;
        renderDeckProgress();
      }
    };
    await Promise.all(Array.from({ length: Math.min(DECK_PARALLEL, lines.length) }, worker));
    d.searching = false;
    if (failed && !all.size) {
      renderDeckProgress();
      toast(`${T('load_error')} (${failed})`, 'error');
      return;
    }
    setOffers([...all.values()]);
    // Zeile -> Kartengruppe
    for (const line of lines) {
      let best = null;
      let bestCount = 0;
      for (const g of state.groups.values()) {
        const c = g.offers.filter((o) => nameKeys(o).has(line.n)).length;
        if (c > bestCount) [best, bestCount] = [g.key, c];
      }
      line.key = best;
    }
    state.filters = emptyFilters();
    state.page = 1;
    state.qty = {};
    state.expanded = new Set();
    d.searched = true;
    d.editing = false;
    renderShell();
    (mount.querySelector('.kx-deck-compact') || mount.querySelector('.kx-deck-results'))?.scrollIntoView({ block: 'start' });
    window.scrollBy(0, -stickyOffset() - 8);
  }

  // Gewünschte Menge auf die günstigsten (bereits gefilterten, nach Preis sortierten) Versionen verteilen
  function allocate(offers, wanted) {
    const picks = [];
    let left = wanted;
    let sum = 0;
    for (const o of offers) {
      if (left <= 0) break;
      const take = Math.min(left, o.qty);
      if (take <= 0) continue;
      picks.push([o.id, take]);
      sum += take * o.price;
      left -= take;
    }
    return { picks, got: wanted - left, sum };
  }

  function computeDeckResults() {
    const base = computeResults();
    const vis = new Map(base.list.map((r) => [r.group.key, r]));
    const searching = !!(state.filters.q || state.filters.exactKey);
    const picks = new Map();
    const rows = state.deck.lines.map((line, idx) => {
      const r = line.key ? vis.get(line.key) : null;
      const offers = r ? r.offers : [];
      const a = allocate(offers, line.qty);
      a.picks.forEach(([id, q]) => picks.set(id, (picks.get(id) || 0) + q));
      return {
        line,
        idx,
        group: line.key ? state.groups.get(line.key) : null,
        offers,
        ...a,
        minPrice: offers.length ? offers[0].price : Infinity,
        firstRank: offers.length ? Math.min(...offers.map((o) => o.rank ?? Infinity)) : Infinity,
      };
    });
    state.deck.picks = picks;
    const shown = rows.filter((r) => r.offers.length);
    const byName = (a, b) => a.group.display.localeCompare(b.group.display, LOCALE);
    const sorters = {
      deck: (a, b) => a.idx - b.idx,
      new: (a, b) => a.idx - b.idx,
      name: byName,
      name_desc: (a, b) => -byName(a, b),
      price: (a, b) => a.minPrice - b.minPrice || byName(a, b),
      price_desc: (a, b) => b.minPrice - a.minPrice || byName(a, b),
      set: (a, b) => (a.offers[0].setCode || '').localeCompare(b.offers[0].setCode || '') || byName(a, b),
    };
    shown.sort(sorters[state.filters.sort] || sorters.deck);
    const wanted = rows.reduce((s, r) => s + r.line.qty, 0);
    const got = rows.reduce((s, r) => s + r.got, 0);
    const sum = rows.reduce((s, r) => s + r.sum, 0);
    return {
      base,
      rows,
      shown,
      missing: searching ? [] : rows.filter((r) => r.got < r.line.qty),
      wanted,
      got,
      sum,
      complete: rows.filter((r) => r.got >= r.line.qty).length,
      partial: rows.filter((r) => r.got > 0 && r.got < r.line.qty).length,
      none: rows.filter((r) => r.got === 0).length,
    };
  }

  const cartIcon = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6.2"/><circle cx="10" cy="20" r="1.4"/><circle cx="17" cy="20" r="1.4"/></svg>';

  function deckHead(row) {
    const ok = row.got >= row.line.qty;
    return `
      <div class="kx-deck-status ${ok ? 'is-ok' : 'is-part'}">
        <span class="kx-deck-qty">${row.line.qty}×</span>
        <span class="kx-deck-state">${ok ? '✓' : '⚠'} ${esc(T('deck_of', { a: row.got, b: row.line.qty }))}</span>
        <span class="kx-deck-sum">${money(row.sum)}</span>
        <button type="button" class="kx-btn kx-btn--small" data-action="deck-add-card" data-line="${row.idx}" ${row.got ? '' : 'disabled'}>${cartIcon}<span>${esc(T('deck_add_card', { n: row.got }))}</span></button>
      </div>`;
  }

  function renderDeckGame(g) {
    const active = state.game && state.game.id === g.id;
    return `<button type="button" class="kx-deck-game${active ? ' is-active' : ''}" data-action="deck-game" data-game="${esc(g.id)}" aria-pressed="${active}">
      ${g.logo ? `<img src="${esc(g.logo)}" alt="${esc(g.label)}" loading="lazy">` : `<span>${esc(g.label)}</span>`}
    </button>`;
  }

  function renderDeckShell() {
    const d = state.deck;
    const totalCards = d.lines.reduce((s, l) => s + l.qty, 0);
    mount.innerHTML = `
      <div class="kx-deck">
        <section class="kx-deck-input" ${d.editing ? '' : 'hidden'}>
          <h2 class="kx-deck-title">${esc(T('deck_title'))}</h2>
          <p class="kx-muted">${esc(T('deck_intro'))}</p>
          ${GAMES.length > 1 ? `<div class="kx-deck-games" role="group" aria-label="${esc(T('choose_game'))}">${GAMES.map(renderDeckGame).join('')}</div>` : ''}
          <textarea data-ref="deck-text" rows="12" spellcheck="false" placeholder="${esc(T('deck_placeholder'))}">${esc(d.text)}</textarea>
          <div class="kx-deck-actions">
            <button type="button" class="kx-btn kx-btn--primary" data-action="deck-search" ${d.searching ? 'disabled' : ''}>${esc(T('deck_search'))}</button>
            ${d.searched ? `<button type="button" class="kx-btn kx-btn--ghost" data-action="deck-cancel-edit">${esc(T('deck_cancel'))}</button>` : ''}
            <span class="kx-deck-progress" data-ref="deck-progress"></span>
          </div>
        </section>
        ${
          d.searched && !d.editing
            ? `<div class="kx-deck-compact">
                <span><b>${esc(state.game?.label || '')}</b> · ${esc(T('deck_lines', { n: totalCards, m: d.lines.length }))}</span>
                <button type="button" class="kx-btn kx-btn--ghost kx-btn--small" data-action="deck-edit">${esc(T('deck_edit'))}</button>
              </div>`
            : ''
        }
        ${
          d.searched
            ? `<div class="kx-layout kx-deck-results${state.sidebarOpen ? ' is-sidebar-open' : ''}">
                <aside class="kx-sidebar" data-ref="sidebar" aria-label="${esc(T('filter'))}"></aside>
                <div class="kx-backdrop" data-action="close-sidebar"></div>
                <main class="kx-main">
                  <div class="kx-searchbar">
                    <div class="kx-search">
                      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
                      <input type="search" data-ref="q" placeholder="${esc(T('deck_filter_placeholder'))}" value="${esc(state.filters.q)}" autocomplete="off" autocorrect="off" spellcheck="false" enterkeyhint="search">
                      <button type="button" class="kx-search-clear" data-action="clear-q" aria-label="${esc(T('search_clear'))}" ${state.filters.q ? '' : 'hidden'}>×</button>
                      <ul class="kx-suggest" data-ref="suggest" role="listbox" hidden></ul>
                    </div>
                    <button type="button" class="kx-filter-toggle" data-action="open-sidebar">${esc(T('filter'))}</button>
                  </div>
                  <div data-ref="results"></div>
                </main>
              </div>`
            : ''
        }
        <div class="kx-zoom" data-ref="zoom" data-action="close-zoom" hidden><img alt=""></div>
        <div class="kx-toast" data-ref="toast" role="status" aria-live="polite"></div>
      </div>`;
    renderDeckProgress();
    if (d.searched) {
      renderDeckResults();
      renderSidebar();
    }
    updateSticky();
  }

  function renderDeckProgress() {
    const el = mount.querySelector('[data-ref="deck-progress"]');
    const btn = mount.querySelector('[data-action="deck-search"]');
    const d = state.deck;
    if (btn) btn.disabled = d.searching;
    if (!el) return;
    el.innerHTML = d.searching
      ? `<span class="kx-spinner"></span>${esc(T('deck_searching', { i: d.done, n: d.lines.length }))}`
      : d.unparsed.length && d.editing
      ? esc(T('deck_unparsed', { n: d.unparsed.length })) + ': ' + d.unparsed.slice(0, 3).map((x) => `„${esc(x)}“`).join(', ')
      : '';
  }

  function renderDeckResults() {
    const el = mount.querySelector('[data-ref="results"]');
    if (!el) return;
    const D = computeDeckResults();
    lastResults = D.base;
    const pages = Math.max(1, Math.ceil(D.shown.length / PAGE_SIZE));
    if (state.page > pages) state.page = pages;
    const slice = D.shown.slice((state.page - 1) * PAGE_SIZE, state.page * PAGE_SIZE);
    const unparsed = state.deck.unparsed;
    const missingBox = D.missing.length || unparsed.length
      ? `<details class="kx-deck-missing" ${D.missing.length + unparsed.length <= 6 ? 'open' : ''}>
          <summary>⚠ ${esc(D.missing.length ? T('deck_missing_title', { n: D.missing.length }) : T('deck_unparsed', { n: unparsed.length }))}</summary>
          <ul>${D.missing
            .map(
              (r) =>
                `<li><b>${r.line.qty}× ${esc(r.group?.display || r.line.name)}</b> – ${esc(
                  !r.group ? T('deck_not_found') : r.got ? T('deck_only', { a: r.got }) : T('deck_filtered')
                )}</li>`
            )
            .join('')}${unparsed.map((x) => `<li class="kx-muted">„${esc(x)}“ – ${esc(T('deck_unparsed_line'))}</li>`).join('')}</ul>
          ${D.missing.some((r) => r.group) && hasActiveFilters() ? `<button type="button" class="kx-btn kx-btn--ghost kx-btn--small" data-action="reset-filters">${esc(T('reset_filters'))}</button>` : ''}
        </details>`
      : '';
    const body = slice.length
      ? slice.map((row) => renderGroup({ group: row.group, offers: row.offers, deckHead: deckHead(row) })).join('')
      : `<div class="kx-empty">${esc(state.offers.length ? T('no_results') : T('deck_none_found'))}${
          hasActiveFilters() ? `<br><button type="button" class="kx-btn kx-btn--ghost" data-action="reset-filters">${esc(T('reset_filters'))}</button>` : ''
        }</div>`;
    el.innerHTML = `
      <div class="kx-deckbar">
        <div class="kx-deckbar-info">
          <div><b>${esc(T('deck_of', { a: D.got, b: D.wanted }))}</b> ${esc(T('cards'))} · ✓ ${D.complete} · ⚠ ${D.partial} · ✗ ${D.none}</div>
          <div class="kx-deckbar-sum">${esc(T('deck_cheapest'))}: <b>${money(D.sum)}</b></div>
        </div>
        <button type="button" class="kx-btn kx-btn--primary kx-deckbar-add" data-action="deck-add-all" ${D.got ? '' : 'disabled'}>${cartIcon}<span>${esc(T('deck_add_all', { n: D.got }))}</span></button>
      </div>
      ${missingBox}
      <div class="kx-resultbar">
        <span class="kx-summary" data-ref="summary"><b>${D.shown.length}</b> ${esc(T('cards'))}</span>
        ${activeChips()}
        <span data-ref="pager-top">${pager(pages)}</span>
      </div>
      <div class="kx-groups">${body}</div>
      <div class="kx-resultbar kx-resultbar--bottom" data-ref="pager-bottom">${pager(pages)}</div>`;
    const filterBtn = mount.querySelector('.kx-filter-toggle');
    if (filterBtn) filterBtn.textContent = activeFilterCount() ? T('filter_count', { n: activeFilterCount() }) : T('filter');
  }

  async function cartAddMany(items) {
    // Shopify nimmt mehrere Positionen in einem Aufruf; bei Fehlern (z. B. Bestand inzwischen weg) einzeln nachlegen
    const failed = [];
    let added = 0;
    for (let i = 0; i < items.length; i += 50) {
      const chunk = items.slice(i, i + 50);
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: chunk.map(([id, quantity]) => ({ id: Number(id), quantity })) }),
      });
      if (res.ok) {
        added += chunk.reduce((s, [, q]) => s + q, 0);
        continue;
      }
      for (const [id, q] of chunk) {
        try {
          await cartAdd(id, q);
          added += q;
        } catch (e) {
          failed.push(id);
        }
      }
    }
    return { added, failed };
  }

  async function deckAdd(picks, btn, openCart = false) {
    if (!picks.length) return;
    if (btn) {
      btn.disabled = true;
      btn.classList.add('is-busy');
    }
    try {
      const { added, failed } = await cartAddMany(picks);
      await syncCart();
      refreshThemeCart();
      if (failed.length) {
        const names = failed.map((id) => state.groups.get(groupKeyOf(state.offers.find((o) => o.id === id) || {}))?.display).filter(Boolean);
        toast(T('deck_add_partial', { n: added, m: failed.length }) + (names.length ? ` (${names.slice(0, 3).join(', ')})` : ''), 'error');
      } else {
        toast(T('deck_added', { n: added }));
      }
      if (added && openCart) openThemeCart();
    } catch (err) {
      toast(err.message || T('add_failed'), 'error');
    } finally {
      if (btn) {
        btn.classList.remove('is-busy');
        btn.disabled = false;
      }
    }
  }

  function deckSetGame(g) {
    state.game = g;
    if (!window.Shopify?.designMode) syncUrl(g);
    const ta = mount.querySelector('[data-ref="deck-text"]');
    if (ta) state.deck.text = ta.value;
    state.deck.editing = true;
    renderShell();
  }

  function deckStart() {
    mount.classList.add('kx--deck');
    state.game = DEFAULT_GAME || GAMES[0];
    try {
      state.deck.text = localStorage.getItem(DECK_STORE) || '';
    } catch (e) {
      /* egal */
    }
    renderShell();
    syncCart();
    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
  }

  async function deckClick(action, btn) {
    const d = state.deck;
    switch (action) {
      case 'deck-game': {
        const g = GAMES.find((x) => x.id === btn.dataset.game);
        if (g && g !== state.game) deckSetGame(g);
        return true;
      }
      case 'deck-search':
        await searchDeck();
        return true;
      case 'deck-edit':
        d.editing = true;
        renderShell();
        mount.querySelector('[data-ref="deck-text"]')?.focus();
        return true;
      case 'deck-cancel-edit':
        d.editing = false;
        renderShell();
        return true;
      case 'deck-add-all':
        await deckAdd([...d.picks.entries()], btn, true);
        return true;
      case 'deck-add-card': {
        const row = computeDeckResults().rows[Number(btn.dataset.line)];
        if (row) await deckAdd(row.picks, btn);
        return true;
      }
    }
    return false;
  }

  // ---------------------------------------------------------------------------------------------
  // Events
  // ---------------------------------------------------------------------------------------------
  mount.addEventListener('pointerdown', (e) => rememberSidebarAnchor(e.target), true);
  mount.addEventListener('focusin', (e) => rememberSidebarAnchor(e.target), true);

  mount.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-action]');
    if (!btn || !mount.contains(btn)) return;
    const action = btn.dataset.action;
    const f = state.filters;
    if (DECK && action.startsWith('deck-')) {
      await deckClick(action, btn);
      return;
    }

    switch (action) {
      case 'toggle-games': {
        const menu = mount.querySelector('[data-ref="gamemenu"]');
        if (menu) {
          menu.hidden = !menu.hidden;
          btn.setAttribute('aria-expanded', String(!menu.hidden));
        }
        break;
      }
      case 'game': {
        closeGameMenu();
        const g = GAMES.find((x) => x.id === btn.dataset.game);
        if (g && (!state.game || state.game.id !== g.id)) selectGame(g);
        break;
      }
      case 'reload':
        if (state.game) selectGame(state.game, { force: true });
        break;
      case 'open-sidebar':
        state.sidebarOpen = true;
        mount.querySelector('.kx-layout')?.classList.add('is-sidebar-open');
        break;
      case 'close-sidebar':
        state.sidebarOpen = false;
        mount.querySelector('.kx-layout')?.classList.remove('is-sidebar-open');
        break;
      case 'cond':
        f.minCond = btn.dataset.cond;
        applyFilter();
        break;
      case 'reset-filters': {
        const sort = f.sort;
        state.filters = emptyFilters();
        state.filters.sort = sort;
        state.setSearch = '';
        const q = mount.querySelector('[data-ref="q"]');
        if (q) q.value = '';
        mount.querySelector('[data-action="clear-q"]')?.setAttribute('hidden', '');
        applyFilter();
        break;
      }
      case 'remove-filter': {
        const k = btn.dataset.key;
        const v = btn.dataset.value;
        if (k === 'exact') {
          f.exactKey = '';
          f.q = '';
          const q = mount.querySelector('[data-ref="q"]');
          if (q) q.value = '';
        } else if (f[k] instanceof Set) f[k].delete(v);
        else if (k === 'foil') f.foil = 'any';
        else if (k === 'firstEd') f.firstEd = 'any';
        else f[k] = '';
        applyFilter();
        break;
      }
      case 'clear-q': {
        f.q = '';
        f.exactKey = '';
        const q = mount.querySelector('[data-ref="q"]');
        if (q) {
          q.value = '';
          q.focus();
        }
        btn.hidden = true;
        hideSuggest();
        update();
        break;
      }
      case 'suggest': {
        const g = state.groups.get(btn.dataset.key);
        if (!g) break;
        f.exactKey = g.key;
        f.q = g.display;
        const q = mount.querySelector('[data-ref="q"]');
        if (q) {
          q.value = g.display;
          q.blur();
        }
        hideSuggest();
        applyFilter();
        break;
      }
      case 'page': {
        const p = parseInt(btn.dataset.page, 10);
        if (p >= 1) {
          state.page = p;
          renderResults();
          mount.querySelector('.kx-main')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        break;
      }
      case 'qty': {
        const row = btn.closest('[data-offer]');
        const o = state.offers.find((x) => x.id === row.dataset.offer);
        if (!o) break;
        const next = Math.max(1, Math.min(o.qty, (state.qty[o.id] || 1) + parseInt(btn.dataset.delta, 10)));
        state.qty[o.id] = next;
        row.querySelector('[data-ref="qty"]').textContent = next;
        const [minus, plus] = row.querySelectorAll('[data-action="qty"]');
        minus.disabled = next <= 1;
        plus.disabled = next >= o.qty;
        break;
      }
      case 'add': {
        const row = btn.closest('[data-offer]');
        const o = state.offers.find((x) => x.id === row.dataset.offer);
        if (!o || btn.disabled) break;
        const qty = Math.min(state.qty[o.id] || 1, o.qty);
        btn.disabled = true;
        btn.classList.add('is-busy');
        try {
          await cartAdd(o.id, qty);
          await syncCart();
          refreshThemeCart();
          btn.classList.remove('is-busy');
          btn.classList.add('is-done');
          toast(T('added', { qty, name: state.groups.get(groupKeyOf(o))?.display || o.title }));
          setTimeout(() => {
            btn.classList.remove('is-done');
            btn.disabled = false;
          }, 1400);
        } catch (err) {
          btn.classList.remove('is-busy');
          btn.disabled = false;
          toast(err.message || T('add_failed'), 'error');
        }
        break;
      }
      case 'facet-more': {
        const k = btn.dataset.facet;
        state.facetOpen.has(k) ? state.facetOpen.delete(k) : state.facetOpen.add(k);
        renderSidebar();
        break;
      }
      case 'expand': {
        const k = btn.dataset.key;
        state.expanded.has(k) ? state.expanded.delete(k) : state.expanded.add(k);
        renderResults();
        break;
      }
      case 'zoom': {
        const z = mount.querySelector('[data-ref="zoom"]');
        if (z && btn.dataset.src) {
          z.querySelector('img').src = btn.dataset.src;
          z.hidden = false;
        }
        break;
      }
      case 'close-zoom':
        btn.hidden = true;
        break;
      case 'lang':
        switchLanguage(btn.dataset.lang);
        break;
      case 'open-cart':
        openThemeCart();
        break;
      case 'checkout':
        if (state.cart.count) window.location.href = root + 'checkout';
        break;
    }
  });

  mount.addEventListener('keydown', (e) => {
    if (DECK && e.key === 'Enter' && (e.ctrlKey || e.metaKey) && e.target.matches('[data-ref="deck-text"]')) searchDeck();
  });

  mount.addEventListener('input', (e) => {
    const t = e.target;
    if (t.matches('[data-ref="deck-text"]')) {
      state.deck.text = t.value;
      return;
    }
    const f = state.filters;
    if (t.matches('[data-ref="q"]')) {
      f.q = t.value;
      f.exactKey = '';
      mount.querySelector('[data-action="clear-q"]')?.toggleAttribute('hidden', !t.value);
      renderSuggest();
      applySearch();
    } else if (t.matches('[data-ref="set-search"]')) {
      state.setSearch = t.value;
      const pos = t.selectionStart;
      renderSidebar();
      const again = mount.querySelector('[data-ref="set-search"]');
      if (again) {
        again.focus();
        again.setSelectionRange(pos, pos);
      }
    } else if (t.matches('[data-filter="priceMin"],[data-filter="priceMax"]')) {
      f[t.dataset.filter] = t.value.trim();
      debouncedPrice();
    }
  });

  const debouncedPrice = debounce(() => applyFilter({ sidebar: false }), 500);

  mount.addEventListener('change', (e) => {
    const t = e.target;
    const f = state.filters;
    if (t.matches('[data-binary]')) {
      rememberSidebarAnchor(t);
      f[t.dataset.binary] = t.checked ? t.value : 'any';
      applyFilter();
    } else if (t.matches('[data-facet]')) {
      rememberSidebarAnchor(t);
      const set = f[t.dataset.facet];
      t.checked ? set.add(t.value) : set.delete(t.value);
      applyFilter();
    } else if (t.matches('[data-filter="sort"]')) {
      f.sort = t.value;
      applyFilter({ sidebar: false });
    } else if (t.matches('[data-filter="priceMin"],[data-filter="priceMax"]')) {
      update();
    }
  });

  mount.addEventListener('keydown', (e) => {
    if (e.target.matches('[data-ref="q"]') && e.key === 'Enter') {
      hideSuggest();
      e.target.blur();
      update();
    }
    if (e.key === 'Escape') {
      hideSuggest();
      const z = mount.querySelector('[data-ref="zoom"]');
      if (z) z.hidden = true;
    }
  });

  function closeGameMenu() {
    const menu = mount.querySelector('[data-ref="gamemenu"]');
    if (menu && !menu.hidden) {
      menu.hidden = true;
      mount.querySelector('.kx-gamepick-btn')?.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.kx-search')) hideSuggest();
    if (!e.target.closest('.kx-gamepick')) closeGameMenu();
  });

  // ---------------------------------------------------------------------------------------------
  // Scrollen (Maus/Trackpad, Querformat):
  //  - Rad über der Filterspalte (inkl. Rand links daneben) scrollt die Filter; sind die Filter am Ende,
  //    scrollt die Seite weiter.
  //  - Rad über den Karten scrollt die Seite; ist die Seite am Ende (bzw. ganz oben), laufen die Filter weiter.
  //  -> Mit einer Scrollbewegung ist alles erreichbar. Touch scrollt nativ (Filter -> Seite verkettet).
  // ---------------------------------------------------------------------------------------------
  document.addEventListener(
    'wheel',
    (e) => {
      if (e.ctrlKey || window.innerWidth < 1024) return;
      const side = mount.querySelector('.kx-sidebar');
      if (!side || e.target.closest('.kx-top, .kx-suggest, .kx-zoom, .kx-gamemenu, select')) return;
      const dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaMode === 2 ? e.deltaY * window.innerHeight : e.deltaY;
      if (!dy) return;
      const canDown = side.scrollTop + side.clientHeight < side.scrollHeight - 1;
      const canUp = side.scrollTop > 0;
      const r = side.getBoundingClientRect();
      const overFilters = e.clientX <= r.right + 12 && e.clientY >= r.top;
      const doc = document.scrollingElement || document.documentElement;
      const pageAtBottom = doc.scrollTop + window.innerHeight >= doc.scrollHeight - 2;
      const pageAtTop = doc.scrollTop <= 0;
      const moveFilters = overFilters
        ? (dy > 0 && canDown) || (dy < 0 && canUp)
        : (dy > 0 && pageAtBottom && canDown) || (dy < 0 && pageAtTop && canUp);
      if (moveFilters) {
        side.scrollTop += dy;
        e.preventDefault();
      }
    },
    { passive: false }
  );

  // ---------------------------------------------------------------------------------------------
  // Zustands-Erklärung (Hover bzw. Antippen auf ein Zustands-Kürzel)
  // ---------------------------------------------------------------------------------------------
  const tip = document.createElement('div');
  tip.className = 'kx-tip';
  tip.setAttribute('role', 'tooltip');
  tip.hidden = true;
  mount.after(tip);
  let tipTimer;
  function showTip(el, autoHide) {
    const code = el.dataset.condTip;
    if (!COND_INFO[code]) return;
    tip.innerHTML = `<span class="kx-cond kx-cond--${code}">${code}</span> <b>${esc(COND_LABEL[code])}</b><p>${esc(COND_INFO[code])}</p>`;
    tip.hidden = false;
    const r = el.getBoundingClientRect();
    const w = tip.offsetWidth;
    const h = tip.offsetHeight;
    let left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
    let top = r.top - h - 10;
    if (top < 8) top = r.bottom + 10;
    tip.style.left = `${left}px`;
    tip.style.top = `${top}px`;
    clearTimeout(tipTimer);
    if (autoHide) tipTimer = setTimeout(hideTip, 3500);
  }
  function hideTip() {
    tip.hidden = true;
  }
  mount.addEventListener('pointerover', (e) => {
    const el = e.target.closest('[data-cond-tip]');
    if (el && e.pointerType === 'mouse') showTip(el, false);
  });
  mount.addEventListener('pointerout', (e) => {
    if (e.pointerType === 'mouse' && e.target.closest('[data-cond-tip]')) hideTip();
  });
  mount.addEventListener('pointerup', (e) => {
    const el = e.target.closest('[data-cond-tip]');
    if (el && e.pointerType !== 'mouse') {
      const code = el.dataset.condTip;
      // nach dem Neuzeichnen der Sidebar das neue Element verwenden
      requestAnimationFrame(() => {
        const fresh = el.isConnected ? el : mount.querySelector(`.kx-chip[data-cond-tip="${code}"]`);
        if (fresh) showTip(fresh, true);
      });
    } else if (!el) hideTip();
  });
  mount.addEventListener('focusin', (e) => {
    const el = e.target.closest('[data-cond-tip]');
    if (el) showTip(el, false);
  });
  mount.addEventListener('focusout', hideTip);
  window.addEventListener('scroll', hideTip, { passive: true });

  // ---------------------------------------------------------------------------------------------
  // Warenkorb-Status + Inaktivitäts-Reset
  // ---------------------------------------------------------------------------------------------
  async function syncCart() {
    try {
      const cart = await cartGet();
      state.cart.count = cart.item_count || 0;
      state.cart.total = cart.total_price || 0;
    } catch (e) {
      /* egal */
    }
    renderCart();
  }
  document.addEventListener('cart:change', syncCart);
  document.addEventListener('cart:refresh', () => setTimeout(syncCart, 300));

  let idleTimer = null;
  let lastActivity = Date.now();
  let pristine = true; // seit dem letzten Zurücksetzen nicht benutzt
  let resetAt = 0;
  function bumpActivity(e) {
    // Scrollen, das der Reset selbst auslöst (oder Neuzeichnen kurz danach), zählt nicht als Benutzung
    if (e && e.type === 'scroll' && Date.now() - resetAt < 1500) return;
    lastActivity = Date.now();
    pristine = false;
    clearTimeout(idleTimer);
    idleTimer = setTimeout(resetKiosk, IDLE_MS);
  }

  // Tablets/Browser frieren Seiten im Ruhezustand ein (Timer laufen nicht, Seite kommt beim Aufwecken aus dem
  // Zwischenspeicher des Browsers zurück). Deshalb beim Aufwecken und einmal pro Minute nach der Uhrzeit prüfen:
  //  - länger als die Inaktivitätszeit nichts passiert -> Kiosk zurücksetzen (Warenkorb, Filter, Spiel)
  //  - Kartenliste älter als die Cache-Zeit -> im Hintergrund neu laden (auch wenn das Spiel nicht gewechselt wird)
  function checkFreshness() {
    if (DECK || document.visibilityState === 'hidden') return;
    if (!pristine && Date.now() - lastActivity >= IDLE_MS) {
      resetKiosk();
      return;
    }
    if (state.game && !state.loading && !state.refreshing && Date.now() - (state.loadedAt || 0) >= CACHE_MS) {
      loadFresh(state.game, loadToken, { background: true });
    }
  }
  if (!DECK) {
    document.addEventListener('visibilitychange', checkFreshness);
    window.addEventListener('pageshow', (e) => e.persisted && checkFreshness());
    window.addEventListener('focus', checkFreshness);
    setInterval(checkFreshness, 60 * 1000);
  }
  async function resetKiosk() {
    pristine = true;
    resetAt = Date.now();
    clearTimeout(idleTimer);
    try {
      await cartClear();
    } catch (e) {
      /* egal */
    }
    refreshThemeCart();
    closeAnyCart();
    loadToken++;
    state.game = null;
    state.filters = emptyFilters();
    state.offers = [];
    state.groups = new Map();
    state.cart = { count: 0, total: 0 };
    state.qty = {};
    state.sidebarOpen = false;
    window.scrollTo(0, 0);
    if (CFG.idleResetLanguage && CFG.primaryLocale && LOCALE !== CFG.primaryLocale && LANGS.some((l) => l.code === CFG.primaryLocale)) {
      if (DEFAULT_GAME) syncUrl(DEFAULT_GAME);
      else syncUrl(null);
      switchLanguage(CFG.primaryLocale); // lädt die Seite in der Hauptsprache neu
      return;
    }
    if (DEFAULT_GAME) {
      selectGame(DEFAULT_GAME); // Index kommt aus dem Zwischenspeicher -> sofort da
    } else {
      syncUrl(null);
      renderShell();
    }
  }
  if (!DECK) ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((evt) => document.addEventListener(evt, bumpActivity, { passive: true }));

  // ---------------------------------------------------------------------------------------------
  // Start
  // ---------------------------------------------------------------------------------------------
  if (!GAMES.length) {
    mount.innerHTML = `<div class="kx-boot">${esc(T('no_games'))}</div>`;
    return;
  }
  if (DECK) {
    deckStart();
  } else {
    renderShell();
    syncCart();
    bumpActivity();
    if (DEFAULT_GAME) selectGame(DEFAULT_GAME);
  }

  // Theme-Editor: Klick auf einen Block "Spiel" zeigt dieses Spiel in der Vorschau
  document.addEventListener('shopify:block:select', (e) => {
    if (e.detail?.sectionId !== mount.dataset.sectionId) return;
    const g = GAMES.find((x) => x.id === e.detail.blockId);
    if (g && (!state.game || state.game.id !== g.id)) DECK ? deckSetGame(g) : selectGame(g);
  });

  // Für Tests/Debugging
  window.bbKiosk = { state, parseTitle, computeResults };
})();